<template>
  <div>
    <v-card>
      <v-tabs v-model="activeTab" class="partner-bank-tabs" color="primary" slider-color="white" @change="onTabChanged">
        <v-tab>Anlaşmalı Bankalar</v-tab>
        <v-tab>Günlük Altın Özeti</v-tab>
        <v-tab>Altın Alımı Kayıtları</v-tab>
        <v-tab>Nakit Transfer Kayıtları</v-tab>
        <v-tab>Altın Transfer Kayıtları</v-tab>
        <v-tab>Dış Ödemeler</v-tab>
        <v-tab>Beklenen ve Gelen Kayıtları</v-tab>
        <v-tab>Snapshot Geçmişi</v-tab>
      </v-tabs>
      <v-divider></v-divider>

      <v-card-text>
        <v-tabs-items v-model="activeTab">
          <v-tab-item>
            <div class="partner-tab-section">
              <div class="refined-header">
                <div>
                  <h2 class="refined-title">Anlaşmalı Bankalar</h2>
                  <p class="refined-subtitle">Banka listesini filtreleyip listeleyebilirsiniz</p>
                </div>
                <button type="button" class="refined-primary-btn" @click="openBankCreateDialog">
                  <v-icon small class="mr-1">add</v-icon>
                  Yeni Banka Ekle
                </button>
              </div>

              <div class="refined-filters">
                <div class="refined-filter-item">
                  <label class="refined-filter-label">Ara</label>
                  <input
                    v-model="search"
                    type="text"
                    class="refined-input"
                    placeholder="Banka adı veya IBAN belirteci"
                    @input="searchBanks"
                  />
                </div>
                <!-- <div class="refined-filter-item">
                  <label class="refined-filter-label">Tenant</label>
                  <select v-model="tenantFilter" class="refined-select" @change="searchBanks">
                    <option v-for="opt in tenantFilterOptions" :key="String(opt.value)" :value="opt.value">{{ opt.text }}</option>
                  </select>
                </div> -->
                <div class="refined-filter-item">
                  <label class="refined-filter-label">Şirket</label>
                  <select v-model="companyFilter" class="refined-select" @change="searchBanks">
                    <option value="">Tüm Şirketler</option>
                    <option v-for="c in companies" :key="String(c.id)" :value="String(c.id)">{{ c.name }}</option>
                  </select>
                </div>
                <div class="refined-filter-item">
                  <label class="refined-filter-label">Durum</label>
                  <select v-model="statusFilter" class="refined-select" @change="searchBanks">
                    <option v-for="opt in statusOptions" :key="opt.value" :value="opt.value">{{ opt.text }}</option>
                  </select>
                </div>
              </div>

              <div class="refined-table-wrap">
                <div class="refined-table-scroll">
                  <table class="refined-table">
                    <thead>
                      <tr>
                        <!-- <th>Tenant</th> -->
                        <th>Şirket</th>
                        <th>IBAN Belirteci</th>
                        <th>Banka Adı</th>
                        <th>Hesap Milyem</th>
                        <th>Altın (gr)</th>
                        <th>Nakit</th>
                        <th>Durum</th>
                        <th>Oluşturma</th>
                        <th>İşlemler</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-if="loading">
                        <td colspan="10" class="refined-loading">
                          <v-progress-circular indeterminate color="primary" size="32"></v-progress-circular>
                          Yükleniyor...
                        </td>
                      </tr>
                      <tr v-else-if="!paginatedBanks.length">
                        <td colspan="10" class="refined-empty">Kayıt yok</td>
                      </tr>
                      <tr v-for="(item, i) in paginatedBanks" :key="item.id || i" class="refined-row">
                        <!-- <td>{{ getTenantName(item.tenantId) }}</td> -->
                        <td>{{ getCompanyName(item.companyId) }}</td>
                        <td class="refined-cell-bold">{{ item.ibanIdentifier }}</td>
                        <td>{{ item.bankName }}</td>
                        <td>
                          <span v-if="item.accountPurityType" class="refined-chip" :class="'refined-chip-' + getPurityColorSlug(item.accountPurityType)">{{ item.accountPurityType }} Milyem</span>
                          <span v-else class="refined-muted">-</span>
                        </td>
                        <td>
                          <span v-if="item.goldAmountInGrams" class="refined-cell-value">{{ formatGoldAmount(item.goldAmountInGrams) }} <v-icon x-small class="refined-icon-inline">grain</v-icon></span>
                          <span v-else class="refined-muted">-</span>
                        </td>
                        <td>
                          <span v-if="item.cashAmount !== null && item.cashAmount !== undefined" class="refined-cell-value">{{ formatCashAmount(item.cashAmount) }}</span>
                          <span v-else class="refined-muted">-</span>
                        </td>
                        <td>
                          <span class="refined-chip" :class="item.status === 'ACTIVE' ? 'refined-chip-success' : 'refined-chip-error'">{{ item.status === 'ACTIVE' ? 'Aktif' : 'Pasif' }}</span>
                        </td>
                        <td class="refined-muted">{{ formatDate(item.createdDate) }}</td>
                        <td>
                          <v-menu offset-y>
                            <template v-slot:activator="{ on }">
                              <button type="button" class="refined-action-btn" v-on="on">İşlem</button>
                            </template>
                            <v-card class="refined-menu-card">
                              <div class="refined-menu-body">
                                <button type="button" class="refined-menu-btn refined-menu-btn-primary" @click="openBankEditDialog(item)">İŞLEM YAP</button>
                                <button type="button" class="refined-menu-btn refined-menu-btn-amber" @click="openBuyGoldDialog(item)">ALTIN ALIMI</button>
                                <button type="button" class="refined-menu-btn refined-menu-btn-success" @click="openTransferDialog(item)">PARA TRANSFER</button>
                                <button type="button" class="refined-menu-btn refined-menu-btn-amber" @click="openGoldTransferDialog(item)">ALTIN TRANSFERİ</button>
                                <button type="button" class="refined-menu-btn refined-menu-btn-indigo" @click="openExternalPaymentsDialog(item)">DIŞ ÖDEMELER</button>
                                <button type="button" class="refined-menu-btn refined-menu-btn-cyan" @click="openIncomingPaymentDialog(item)">GELEN ÖDEME</button>
                                <div class="refined-menu-divider"></div>
                                <button type="button" class="refined-menu-btn refined-menu-btn-error" @click="confirmDelete(item)">SİL</button>
                              </div>
                            </v-card>
                          </v-menu>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div class="refined-table-footer">
                  <div class="refined-footer-left">
                    <span>Sayfa başına satır:</span>
                    <select v-model.number="banksRowsPerPage" class="refined-rows-select">
                      <option :value="10">10</option>
                      <option :value="20">20</option>
                      <option :value="50">50</option>
                    </select>
                  </div>
                  <span class="refined-pagination-info">{{ banksPaginationInfo }}</span>
                  <div class="refined-footer-actions">
                    <button type="button" class="refined-page-btn" :disabled="banksPage <= 1" @click="banksPage = Math.max(1, banksPage - 1)">
                      <v-icon small>chevron_left</v-icon>
                    </button>
                    <button type="button" class="refined-page-btn" :disabled="banksPage >= banksTotalPages" @click="banksPage = Math.min(banksTotalPages, banksPage + 1)">
                      <v-icon small>chevron_right</v-icon>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </v-tab-item>

          <v-tab-item>
            <div class="partner-tab-section daily-gold-summary">
              <div class="gold-summary-header">
                <div>
                  <h2 class="gold-summary-title">Bugünkü Özet</h2>
                  <p class="gold-summary-date">{{ formatDateOnly(new Date()) }} tarihinde güncellendi</p>
                </div>
                <div class="refined-header-actions">
                  <select v-model="dailySummaryCompanyFilter" class="refined-select" style="min-width: 220px;">
                    <option value="">Tüm Şirketler</option>
                    <option v-for="c in companies" :key="String(c.id)" :value="String(c.id)">{{ c.name }}</option>
                  </select>
                  <button type="button" class="gold-summary-refresh-btn" :disabled="dailyOverviewLoading" @click="loadDailyOverview">
                    <v-icon small class="mr-1">refresh</v-icon>
                    YENİLE
                  </button>
                </div>
              </div>

              <div class="gold-summary-table-wrap">
                <div class="gold-summary-table-scroll">
                  <table class="gold-summary-table">
                    <thead>
                      <tr>
                        <th>Banka</th>
                        <th>Kullanıcı</th>
                        <th>Toplam Gram</th>
                        <th>Toplam Ödeme</th>
                        <th>Ortalama (TL/gr)</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-if="dailyOverviewLoading">
                        <td colspan="5" class="gold-summary-loading">
                          <v-progress-circular indeterminate color="primary" size="32"></v-progress-circular>
                          Yükleniyor...
                        </td>
                      </tr>
                      <tr v-else-if="!filteredDailyPurchasedGold.length">
                        <td colspan="5" class="gold-summary-empty">Kayıt yok</td>
                      </tr>
                      <tr v-for="(item, i) in paginatedDailyPurchased" :key="i" class="gold-summary-row">
                        <td class="gold-summary-cell-name">{{ item.bankName }}</td>
                        <td>{{ getBankUsers(item.bankName) }}</td>
                        <td>{{ formatGr(item.totalGram) }}</td>
                        <td>{{ formatTl(item.totalPayment) }}</td>
                        <td>{{ formatTlPerGr(getAvgTlPerGr(item)) }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div class="gold-summary-table-footer">
                  <div class="gold-summary-footer-left">
                    <span>Sayfa başına satır:</span>
                    <select v-model.number="dailySummaryRowsPerPage" class="gold-summary-rows-select">
                      <option :value="10">10</option>
                      <option :value="20">20</option>
                      <option :value="50">50</option>
                    </select>
                  </div>
                  <span class="gold-summary-pagination-info">{{ dailySummaryPaginationInfo }}</span>
                  <div class="gold-summary-footer-actions">
                    <button type="button" class="gold-summary-page-btn" :disabled="dailySummaryPage <= 1" @click="dailySummaryPage = Math.max(1, dailySummaryPage - 1)">
                      <v-icon small>chevron_left</v-icon>
                    </button>
                    <button type="button" class="gold-summary-page-btn" :disabled="dailySummaryPage >= dailySummaryTotalPages" @click="dailySummaryPage = Math.min(dailySummaryTotalPages, dailySummaryPage + 1)">
                      <v-icon small>chevron_right</v-icon>
                    </button>
                  </div>
                </div>
              </div>

              <div v-if="dailyGoldStock" class="gold-summary-cards">
                <div class="gold-summary-card">
                  <div class="gold-summary-card-head">
                    <span class="gold-summary-card-label">Mevcut Nakit</span>
                    <div class="gold-summary-card-icon gold-summary-icon-emerald"><v-icon small>payments</v-icon></div>
                  </div>
                  <div class="gold-summary-card-value">{{ formatCashAmount(dailyGoldStock.currentCashAmount) }}</div>
                </div>
                <div class="gold-summary-card">
                  <div class="gold-summary-card-head">
                    <span class="gold-summary-card-label">Mevcut Banka Altını</span>
                    <div class="gold-summary-card-icon gold-summary-icon-amber"><v-icon small>account_balance_wallet</v-icon></div>
                  </div>
                  <div class="gold-summary-card-value">{{ formatGoldAmount(dailyGoldStock.availableGoldStock) }} gr</div>
                </div>
                <div class="gold-summary-card">
                  <div class="gold-summary-card-head">
                    <span class="gold-summary-card-label">Bugünkü Has Altın</span>
                    <div class="gold-summary-card-icon gold-summary-icon-yellow"><v-icon small>diamond</v-icon></div>
                  </div>
                  <div class="gold-summary-card-value">{{ formatTlPerGr(dailyGoldStock.dailyHasAltin) }}</div>
                </div>
                <div class="gold-summary-card">
                  <div class="gold-summary-card-head">
                    <span class="gold-summary-card-label">Ortalama Satış Tutarı</span>
                    <div class="gold-summary-card-icon gold-summary-icon-yellow"><v-icon small>calculate</v-icon></div>
                  </div>
                  <div class="gold-summary-card-value">{{ formatTlPerGr(dailyGoldStock.dailyCompletedSalesHasAltin) }}</div>
                </div>
                <div class="gold-summary-card">
                  <div class="gold-summary-card-head">
                    <span class="gold-summary-card-label">Nakit ile Alınabilir</span>
                    <div class="gold-summary-card-icon gold-summary-icon-primary"><v-icon small>shopping_cart</v-icon></div>
                  </div>
                  <div class="gold-summary-card-value">{{ formatGoldAmount(dailyGoldStock.purchasableGoldGramsWithCurrentCash) }} gr</div>
                </div>
                <div class="gold-summary-card">
                  <div class="gold-summary-card-head">
                    <span class="gold-summary-card-label">Toplam Stok</span>
                    <div class="gold-summary-card-icon gold-summary-icon-slate"><v-icon small>inventory_2</v-icon></div>
                  </div>
                  <div class="gold-summary-card-value">{{ formatGoldAmount(dailyGoldStock.goldStockAmount) }} gr</div>
                </div>
                <div class="gold-summary-card">
                  <div class="gold-summary-card-head">
                    <span class="gold-summary-card-label">Çekilmemiş Ödemeler</span>
                    <div class="gold-summary-card-icon gold-summary-icon-rose"><v-icon small>pending_actions</v-icon></div>
                  </div>
                  <div class="gold-summary-card-value">{{ formatCashAmount(dailyGoldStock.dailyUndrawnPayments) }}</div>
                </div>
                <div class="gold-summary-card">
                  <div class="gold-summary-card-head">
                    <span class="gold-summary-card-label">Çekilmemiş Ödemelerle Alınabilir Altın</span>
                    <div class="gold-summary-card-icon gold-summary-icon-indigo"><v-icon small>layers</v-icon></div>
                  </div>
                  <div class="gold-summary-card-value">{{ formatGoldAmount(dailyGoldStock.purchasableGoldWithUndrawnPayment) }} gr</div>
                </div>
                <div class="gold-summary-card">
                  <div class="gold-summary-card-head">
                    <span class="gold-summary-card-label">Toplam Günlük Stok (Çekilmemiş Ödeme Dahil)</span>
                    <div class="gold-summary-card-icon gold-summary-icon-indigo"><v-icon small>layers</v-icon></div>
                  </div>
                  <div class="gold-summary-card-value">{{ formatGoldAmount(dailyGoldStock.goldStockWithUndrawnPayments) }} gr</div>
                </div>
                <div class="gold-summary-card">
                  <div class="gold-summary-card-head">
                    <span class="gold-summary-card-label">Bugünkü Gram Satış</span>
                    <div class="gold-summary-card-icon gold-summary-icon-cyan"><v-icon small>trending_up</v-icon></div>
                  </div>
                  <div class="gold-summary-card-value">{{ formatGoldAmount(dailyGoldStock.dailyTotalGramSales) }} gr</div>
                </div>
                <div class="gold-summary-card">
                  <div class="gold-summary-card-head">
                    <span class="gold-summary-card-label">Bugünkü Satış Tutarı</span>
                    <div class="gold-summary-card-icon gold-summary-icon-green"><v-icon small>monetization_on</v-icon></div>
                  </div>
                  <div class="gold-summary-card-value">{{ formatCashAmount(dailyGoldStock.totalDailyProfit) }}</div>
                </div>
              </div>

              <v-alert v-else-if="!dailyOverviewLoading" type="info" class="gold-summary-no-data">
                Stok özeti bulunamadı.
              </v-alert>
            </div>
          </v-tab-item>

          <v-tab-item>
            <div class="partner-tab-section">
              <div class="refined-header">
                <div>
                  <h2 class="refined-title">Altın Alımı Kayıtları</h2>
                  <p class="refined-subtitle">{{ formatDateOnly(logsDate) }} tarihli kayıtlar</p>
                </div>
                <div class="refined-header-actions">
                  <v-menu
                    v-model="goldLogsDateMenu"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <button type="button" class="refined-date-btn" v-on="on">
                        <v-icon small class="mr-1">event</v-icon>
                        {{ formatDateOnly(logsDate) }}
                      </button>
                    </template>
                    <v-date-picker v-model="logsDate" locale="tr-TR" @input="goldLogsDateMenu = false; refreshActiveLogs()"></v-date-picker>
                  </v-menu>
                  <select v-model="goldLogsCompanyFilter" class="refined-select" style="min-width: 220px;">
                    <option value="">Tüm Şirketler</option>
                    <option v-for="c in companies" :key="String(c.id)" :value="String(c.id)">{{ c.name }}</option>
                  </select>
                  <button type="button" class="refined-primary-btn refined-btn-amber" :disabled="goldLogsLoading" @click="loadGoldBuyLogs">
                    <v-icon small class="mr-1">refresh</v-icon>
                    YENİLE
                  </button>
                </div>
              </div>

              <div class="refined-table-wrap">
                <div class="refined-table-scroll">
                  <table class="refined-table">
                    <thead>
                      <tr>
                        <th>Kayıt</th>
                        <th>Kullanıcı</th>
                        <th class="refined-th-dekont">Dekont</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-if="goldLogsLoading">
                        <td colspan="3" class="refined-loading">
                          <v-progress-circular indeterminate color="primary" size="32"></v-progress-circular>
                          Yükleniyor...
                        </td>
                      </tr>
                      <tr v-else-if="!paginatedGoldLogs.length">
                        <td colspan="3" class="refined-empty">Kayıt yok</td>
                      </tr>
                      <tr v-for="(item, i) in paginatedGoldLogs" :key="i" class="refined-row">
                        <td>{{ buildGoldLogMessage(item.message) }}</td>
                        <td>{{ getUserName(item.userId) }}</td>
                        <td class="refined-cell-dekont">
                          <button
                            v-if="getExtraDataPath(item.extraData)"
                            type="button"
                            class="refined-dekont-btn"
                            @click="openReceiptFromExtraData(item.extraData)"
                          >
                            Dekont
                          </button>
                          <span v-else class="refined-muted">-</span>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div class="refined-table-footer">
                  <div class="refined-footer-left">
                    <span>Sayfa başına satır:</span>
                    <select v-model.number="goldLogsRowsPerPage" class="refined-rows-select">
                      <option :value="10">10</option>
                      <option :value="20">20</option>
                      <option :value="50">50</option>
                    </select>
                  </div>
                  <span class="refined-pagination-info">{{ goldLogsPaginationInfo }}</span>
                  <div class="refined-footer-actions">
                    <button type="button" class="refined-page-btn" :disabled="goldLogsPage <= 1" @click="goldLogsPage = Math.max(1, goldLogsPage - 1)">
                      <v-icon small>chevron_left</v-icon>
                    </button>
                    <button type="button" class="refined-page-btn" :disabled="goldLogsPage >= goldLogsTotalPages" @click="goldLogsPage = Math.min(goldLogsTotalPages, goldLogsPage + 1)">
                      <v-icon small>chevron_right</v-icon>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </v-tab-item>

          <v-tab-item>
            <div class="partner-tab-section">
              <div class="refined-header">
                <div>
                  <h2 class="refined-title">Nakit Transfer Kayıtları</h2>
                  <p class="refined-subtitle">{{ formatDateOnly(logsDate) }} tarihli kayıtlar</p>
                </div>
                <div class="refined-header-actions">
                  <v-menu
                    v-model="cashLogsDateMenu"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <button type="button" class="refined-date-btn" v-on="on">
                        <v-icon small class="mr-1">event</v-icon>
                        {{ formatDateOnly(logsDate) }}
                      </button>
                    </template>
                    <v-date-picker v-model="logsDate" locale="tr-TR" @input="cashLogsDateMenu = false; refreshActiveLogs()"></v-date-picker>
                  </v-menu>
                  <select v-model="cashLogsCompanyFilter" class="refined-select" style="min-width: 220px;">
                    <option value="">Tüm Şirketler</option>
                    <option v-for="c in companies" :key="String(c.id)" :value="String(c.id)">{{ c.name }}</option>
                  </select>
                  <button type="button" class="refined-primary-btn refined-btn-success" :disabled="cashLogsLoading" @click="loadCashTransferLogs">
                    <v-icon small class="mr-1">refresh</v-icon>
                    YENİLE
                  </button>
                </div>
              </div>

              <div class="refined-table-wrap">
                <div class="refined-table-scroll">
                  <table class="refined-table">
                    <thead>
                      <tr>
                        <th>Kayıt</th>
                        <th>Kullanıcı</th>
                        <th class="refined-th-dekont">Dekont</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-if="cashLogsLoading">
                        <td colspan="3" class="refined-loading">
                          <v-progress-circular indeterminate color="primary" size="32"></v-progress-circular>
                          Yükleniyor...
                        </td>
                      </tr>
                      <tr v-else-if="!paginatedCashLogs.length">
                        <td colspan="3" class="refined-empty">Kayıt yok</td>
                      </tr>
                      <tr v-for="(item, i) in paginatedCashLogs" :key="i" class="refined-row">
                        <td>{{ buildCashLogMessage(item.message) }}</td>
                        <td>{{ getUserName(item.userId) }}</td>
                        <td class="refined-cell-dekont">
                          <button
                            v-if="getExtraDataPath(item.extraData)"
                            type="button"
                            class="refined-dekont-btn"
                            @click="openReceiptFromExtraData(item.extraData)"
                          >
                            Dekont
                          </button>
                          <span v-else class="refined-muted">-</span>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div class="refined-table-footer">
                  <div class="refined-footer-left">
                    <span>Sayfa başına satır:</span>
                    <select v-model.number="cashLogsRowsPerPage" class="refined-rows-select">
                      <option :value="10">10</option>
                      <option :value="20">20</option>
                      <option :value="50">50</option>
                    </select>
                  </div>
                  <span class="refined-pagination-info">{{ cashLogsPaginationInfo }}</span>
                  <div class="refined-footer-actions">
                    <button type="button" class="refined-page-btn" :disabled="cashLogsPage <= 1" @click="cashLogsPage = Math.max(1, cashLogsPage - 1)">
                      <v-icon small>chevron_left</v-icon>
                    </button>
                    <button type="button" class="refined-page-btn" :disabled="cashLogsPage >= cashLogsTotalPages" @click="cashLogsPage = Math.min(cashLogsTotalPages, cashLogsPage + 1)">
                      <v-icon small>chevron_right</v-icon>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </v-tab-item>

          <v-tab-item>
            <div class="partner-tab-section">
              <div class="refined-header">
                <div>
                  <h2 class="refined-title">Altın Transfer Kayıtları</h2>
                  <p class="refined-subtitle">{{ formatDateOnly(logsDate) }} tarihli kayıtlar</p>
                </div>
                <div class="refined-header-actions">
                  <v-menu
                    v-model="goldTransferLogsDateMenu"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <button type="button" class="refined-date-btn" v-on="on">
                        <v-icon small class="mr-1">event</v-icon>
                        {{ formatDateOnly(logsDate) }}
                      </button>
                    </template>
                    <v-date-picker v-model="logsDate" locale="tr-TR" @input="goldTransferLogsDateMenu = false; refreshActiveLogs()"></v-date-picker>
                  </v-menu>

                  <select v-model="goldTransferLogsCompanyFilter" class="refined-select" style="min-width: 220px;">
                    <option value="">Tüm Şirketler</option>
                    <option v-for="c in companies" :key="String(c.id)" :value="String(c.id)">{{ c.name }}</option>
                  </select>

                  <button type="button" class="refined-primary-btn refined-btn-amber" :disabled="goldTransferLogsLoading" @click="loadGoldTransferLogs">
                    <v-icon small class="mr-1">refresh</v-icon>
                    YENİLE
                  </button>
                </div>
              </div>

              <div class="refined-table-wrap">
                <div class="refined-table-scroll">
                  <table class="refined-table">
                    <thead>
                      <tr>
                        <th>Kayıt</th>
                        <th>Kullanıcı</th>
                        <th class="refined-th-dekont">Dekont</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-if="goldTransferLogsLoading">
                        <td colspan="3" class="refined-loading">
                          <v-progress-circular indeterminate color="primary" size="32"></v-progress-circular>
                          Yükleniyor...
                        </td>
                      </tr>
                      <tr v-else-if="!paginatedGoldTransferLogs.length">
                        <td colspan="3" class="refined-empty">Kayıt yok</td>
                      </tr>
                      <tr v-for="(item, i) in paginatedGoldTransferLogs" :key="i" class="refined-row">
                        <td>{{ buildGoldTransferLogMessage(item.message) }}</td>
                        <td>{{ getUserName(item.userId) }}</td>
                        <td class="refined-cell-dekont">
                          <button
                            v-if="getExtraDataPath(item.extraData)"
                            type="button"
                            class="refined-dekont-btn"
                            @click="openReceiptFromExtraData(item.extraData)"
                          >
                            Dekont
                          </button>
                          <span v-else class="refined-muted">-</span>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div class="refined-table-footer">
                  <div class="refined-footer-left">
                    <span>Sayfa başına satır:</span>
                    <select v-model.number="goldTransferLogsRowsPerPage" class="refined-rows-select">
                      <option :value="10">10</option>
                      <option :value="20">20</option>
                      <option :value="50">50</option>
                    </select>
                  </div>
                  <span class="refined-pagination-info">{{ goldTransferLogsPaginationInfo }}</span>
                  <div class="refined-footer-actions">
                    <button type="button" class="refined-page-btn" :disabled="goldTransferLogsPage <= 1" @click="goldTransferLogsPage = Math.max(1, goldTransferLogsPage - 1)">
                      <v-icon small>chevron_left</v-icon>
                    </button>
                    <button type="button" class="refined-page-btn" :disabled="goldTransferLogsPage >= goldTransferLogsTotalPages" @click="goldTransferLogsPage = Math.min(goldTransferLogsTotalPages, goldTransferLogsPage + 1)">
                      <v-icon small>chevron_right</v-icon>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </v-tab-item>

          <v-tab-item>
            <div class="partner-tab-section">
              <div class="refined-header">
                <div>
                  <h2 class="refined-title">Dış Ödemeler</h2>
                  <p class="refined-subtitle">{{ formatDateOnly(logsDate) }} tarihli kayıtlar</p>
                </div>
                <div class="refined-header-actions">
                  <v-menu
                    v-model="externalLogsDateMenu"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <button type="button" class="refined-date-btn" v-on="on">
                        <v-icon small class="mr-1">event</v-icon>
                        {{ formatDateOnly(logsDate) }}
                      </button>
                    </template>
                    <v-date-picker v-model="logsDate" locale="tr-TR" @input="externalLogsDateMenu = false; loadExternalPaymentLogs()"></v-date-picker>
                  </v-menu>

                  <select v-model="externalLogsCompanyId" class="refined-select" style="min-width: 220px;">
                    <option value="">Tüm Şirketler</option>
                    <option v-for="c in companies" :key="String(c.id)" :value="String(c.id)">{{ c.name }}</option>
                  </select>

                  <button type="button" class="refined-primary-btn refined-btn-indigo" :disabled="externalLogsLoading" @click="loadExternalPaymentLogs">
                    <v-icon small class="mr-1">refresh</v-icon>
                    YENİLE
                  </button>
                </div>
              </div>

              <div class="refined-filters">
                <div class="refined-filter-item">
                  <label class="refined-filter-label">Ara</label>
                  <input
                    v-model="externalLogsSearch"
                    type="text"
                    class="refined-input"
                    placeholder="Banka, masraf tipi veya tutar ara..."
                  />
                </div>
              </div>

              <div class="refined-table-wrap">
                <div class="refined-table-scroll">
                  <table class="refined-table">
                    <thead>
                      <tr>
                        <th>Şirket</th>
                        <th>Banka</th>
                        <th>Masraf Tipi</th>
                        <th>Tutarı</th>
                        <th>Kullanıcı</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-if="externalLogsLoading">
                        <td colspan="5" class="refined-loading">
                          <v-progress-circular indeterminate color="primary" size="32"></v-progress-circular>
                          Yükleniyor...
                        </td>
                      </tr>
                      <tr v-else-if="!paginatedExternalPaymentLogs.length">
                        <td colspan="5" class="refined-empty">Kayıt yok</td>
                      </tr>
                      <tr v-for="(item, i) in paginatedExternalPaymentLogs" :key="i" class="refined-row">
                        <td>{{ getExternalPaymentCompanyName(item.message) }}</td>
                        <td>{{ getExternalPaymentBankName(item.message) }}</td>
                        <td>{{ getExternalPaymentType(item.message) }}</td>
                        <td>{{ getExternalPaymentAmount(item.message) }}</td>
                        <td>{{ getUserName(item.userId) }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div class="refined-table-footer">
                  <div class="refined-footer-left">
                    <span>Sayfa başına satır:</span>
                    <select v-model.number="externalLogsRowsPerPage" class="refined-rows-select">
                      <option :value="10">10</option>
                      <option :value="20">20</option>
                      <option :value="50">50</option>
                    </select>
                  </div>
                  <span class="refined-pagination-info">{{ externalLogsPaginationInfo }}</span>
                  <div class="refined-footer-actions">
                    <button type="button" class="refined-page-btn" :disabled="externalLogsPage <= 1" @click="externalLogsPage = Math.max(1, externalLogsPage - 1)">
                      <v-icon small>chevron_left</v-icon>
                    </button>
                    <button type="button" class="refined-page-btn" :disabled="externalLogsPage >= externalLogsTotalPages" @click="externalLogsPage = Math.min(externalLogsTotalPages, externalLogsPage + 1)">
                      <v-icon small>chevron_right</v-icon>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </v-tab-item>

          <v-tab-item>
            <div class="partner-tab-section">
              <div class="refined-header">
                <div>
                  <h2 class="refined-title">Beklenen ve Gelen Kayıtları</h2>
                  <p class="refined-subtitle">Bu ay için beklenen/gelen ödemeler kontrol listesi</p>
                </div>
                <div class="refined-header-actions">
                  <button type="button" class="refined-primary-btn" :disabled="expectedPaymentLoading" @click="loadExpectedPaymentCheckLists">
                    <v-icon small class="mr-1">refresh</v-icon>
                    YENİLE
                  </button>
                </div>
              </div>

              <div class="refined-table-wrap">
                <div class="refined-table-scroll">
                  <table class="refined-table">
                    <thead>
                      <tr>
                        <th>Tarih</th>
                        <th>Beklenen</th>
                        <th>Gelen</th>
                        <th>Fark</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-if="expectedPaymentLoading">
                        <td colspan="4" class="refined-loading">
                          <v-progress-circular indeterminate color="primary" size="32"></v-progress-circular>
                          Yükleniyor...
                        </td>
                      </tr>
                      <tr v-else-if="!expectedPaymentCheckLists.length">
                        <td colspan="4" class="refined-empty">Kayıt yok</td>
                      </tr>
                      <tr v-for="(item, i) in expectedPaymentCheckLists" :key="i" class="refined-row">
                        <td>{{ formatDateOnly(item.date || item.Date) }}</td>
                        <td>{{ formatCashAmount(getExpectedPaymentValue(item)) }}</td>
                        <td>{{ formatCashAmount(getIncomingPaymentValue(item)) }}</td>
                        <td>{{ formatCashAmount(getExpectedPaymentDeltaValue(item)) }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </v-tab-item>

          <v-tab-item>
            <div class="partner-tab-section">
              <div class="refined-header">
                <div>
                  <h2 class="refined-title">Snapshot Geçmişi</h2>
                  <p class="refined-subtitle">Günlük banka snapshot kayıtları</p>
                </div>
                <div class="refined-header-actions">
                  <v-menu
                    v-model="snapshotDateMenu"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <button type="button" class="refined-date-btn" v-on="on">
                        <v-icon small class="mr-1">event</v-icon>
                        {{ snapshotDateFilter ? formatDateOnly(snapshotDateFilter) : 'Tümü' }}
                      </button>
                    </template>
                    <v-date-picker v-model="snapshotDateFilter" locale="tr-TR" @input="snapshotDateMenu = false; loadSnapshots()"></v-date-picker>
                  </v-menu>
                  <button type="button" class="refined-primary-btn" @click="snapshotDateFilter = ''; loadSnapshots()">
                    Tümü
                  </button>
                  <button type="button" class="refined-primary-btn refined-btn-success" :disabled="snapshotsLoading" @click="loadSnapshots">
                    <v-icon small class="mr-1">refresh</v-icon>
                    YENİLE
                  </button>
                </div>
              </div>

              <div class="refined-table-wrap">
                <div class="refined-table-scroll">
                  <table class="refined-table">
                    <thead>
                      <tr>
                        <th>Tarih</th>
                        <th>Toplam Nakit</th>
                        <th>Toplam Altın (gr)</th>
                        <th>Banka Sayısı</th>
                        <th>Detay</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-if="snapshotsLoading">
                        <td colspan="5" class="refined-loading">
                          <v-progress-circular indeterminate color="primary" size="32"></v-progress-circular>
                          Yükleniyor...
                        </td>
                      </tr>
                      <tr v-else-if="!paginatedSnapshots.length">
                        <td colspan="5" class="refined-empty">Kayıt yok</td>
                      </tr>
                      <tr v-for="(item, i) in paginatedSnapshots" :key="i" class="refined-row">
                        <td>{{ formatDate(item.createdAt) }}</td>
                        <td>{{ formatCashAmount(getSnapshotData(item).TotalCashStock) }}</td>
                        <td>{{ formatGoldAmount(getSnapshotData(item).TotalGoldStock) }} gr</td>
                        <td>{{ getSnapshotData(item).Snapshot ? getSnapshotData(item).Snapshot.length : 0 }}</td>
                        <td>
                          <button type="button" class="refined-action-btn" @click="openSnapshotDetail(item)">Detay</button>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div class="refined-table-footer">
                  <div class="refined-footer-left">
                    <span>Sayfa başına satır:</span>
                    <select v-model.number="snapshotsRowsPerPage" class="refined-rows-select">
                      <option :value="10">10</option>
                      <option :value="20">20</option>
                      <option :value="50">50</option>
                    </select>
                  </div>
                  <span class="refined-pagination-info">{{ snapshotsPaginationInfo }}</span>
                  <div class="refined-footer-actions">
                    <button type="button" class="refined-page-btn" :disabled="snapshotsPage <= 1" @click="snapshotsPage = Math.max(1, snapshotsPage - 1)">
                      <v-icon small>chevron_left</v-icon>
                    </button>
                    <button type="button" class="refined-page-btn" :disabled="snapshotsPage >= snapshotsTotalPages" @click="snapshotsPage = Math.min(snapshotsTotalPages, snapshotsPage + 1)">
                      <v-icon small>chevron_right</v-icon>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </v-tab-item>

        </v-tabs-items>
      </v-card-text>
    </v-card>

    <v-dialog v-model="snapshotDetailDialog" max-width="1100px">
      <v-card class="bank-modal">
        <v-card-title class="headline white--text teal elevation-2">
          <v-icon left color="white" size="28">camera_alt</v-icon>
          <span class="font-weight-bold">Snapshot Detay — {{ snapshotDetailDate }}</span>
          <v-spacer></v-spacer>
          <v-btn icon dark @click="snapshotDetailDialog = false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="pa-4">
          <div class="refined-filters mb-4">
            <div class="refined-filter-item">
              <label class="refined-filter-label">Şirket</label>
              <select v-model="snapshotDetailCompanyFilter" class="refined-select" style="min-width: 220px;">
                <option value="">Tüm Şirketler</option>
                <option v-for="c in companies" :key="String(c.id)" :value="String(c.id)">{{ c.name }}</option>
              </select>
            </div>
          </div>
          <div class="gold-summary-cards mb-4" v-if="snapshotDetailData">
            <div class="gold-summary-card">
              <div class="gold-summary-card-head">
                <span class="gold-summary-card-label">Toplam Nakit</span>
                <div class="gold-summary-card-icon gold-summary-icon-emerald"><v-icon small>payments</v-icon></div>
              </div>
              <div class="gold-summary-card-value">{{ formatCashAmount(snapshotDetailData.TotalCashStock) }}</div>
            </div>
            <div class="gold-summary-card">
              <div class="gold-summary-card-head">
                <span class="gold-summary-card-label">Toplam Altın</span>
                <div class="gold-summary-card-icon gold-summary-icon-amber"><v-icon small>account_balance_wallet</v-icon></div>
              </div>
              <div class="gold-summary-card-value">{{ formatGoldAmount(snapshotDetailData.TotalGoldStock) }} gr</div>
            </div>
          </div>
          <div class="refined-table-wrap" v-if="snapshotDetailData && snapshotDetailData.Snapshot">
            <div class="refined-table-scroll">
              <table class="refined-table">
                <thead>
                  <tr>
                    <th>Şirket</th>
                    <th>IBAN Belirteci</th>
                    <th>Banka Adı</th>
                    <th>Hesap Milyem</th>
                    <th>Altın (gr)</th>
                    <th>Nakit</th>
                    <th>Durum</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(bank, bi) in filteredSnapshotDetailData" :key="bi" class="refined-row">
                    <td>{{ getCompanyName(bank.CompanyId) }}</td>
                    <td class="refined-cell-bold">{{ bank.IbanIdentifier }}</td>
                    <td>{{ bank.BankName }}</td>
                    <td>
                      <span v-if="bank.AccountPurityType" class="refined-chip" :class="'refined-chip-' + getPurityColorSlug(bank.AccountPurityType)">{{ bank.AccountPurityType }} Milyem</span>
                      <span v-else class="refined-muted">-</span>
                    </td>
                    <td>{{ formatGoldAmount(bank.GoldAmountInGrams) }} gr</td>
                    <td>{{ formatCashAmount(bank.CashAmount) }}</td>
                    <td>
                      <span class="refined-chip" :class="bank.Status === 'ACTIVE' ? 'refined-chip-success' : 'refined-chip-error'">{{ bank.Status === 'ACTIVE' ? 'Aktif' : 'Pasif' }}</span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="deleteDialog" max-width="400">
      <v-card>
        <v-card-title class="headline">Silme Onayı</v-card-title>
        <v-card-text>
          <strong>{{ bankToDelete && bankToDelete.bankName }}</strong> bankasını silmek istediğinizden emin misiniz?
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="grey" flat @click="deleteDialog = false">İptal</v-btn>
          <v-btn color="error" @click="deleteBank" :loading="deleting">Sil</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="bankEditDialog" max-width="980px" persistent>
      <v-card class="bank-modal">
        <v-card-title class="headline white--text primary elevation-2">
          <v-icon left color="white" size="28">account_balance</v-icon>
          <span class="font-weight-bold">Banka İşlemleri</span>
          <v-spacer></v-spacer>
          <v-btn icon dark @click="closeBankEditDialog" :disabled="bankEditSaving || companiesLoading">
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text class="pa-4">
          <v-container grid-list-md>
            <v-card class="mb-1 modern-card" outlined>
              <v-card-title class="subtitle-1 primary--text py-2">
                <v-icon left color="primary">tune</v-icon>
                Banka Bilgileri
              </v-card-title>
              <v-divider></v-divider>
              <v-card-text>
                <v-layout wrap>
                  <v-flex xs12 sm4 class="pr-sm-2">
                    <v-select
                      v-model="bankEditModel.tenantId"
                      :items="tenantOptions"
                      item-text="tenantName"
                      item-value="tenantId"
                      label="Tenant"
                      outlined
                      dense
                      :disabled="bankEditSaving"
                    ></v-select>
                  </v-flex>
                  <v-flex xs12 sm4 class="px-sm-2">
                    <v-select
                      v-model="bankEditModel.companyId"
                      :items="companies"
                      item-text="name"
                      item-value="id"
                      label="Şirket"
                      outlined
                      dense
                      :loading="companiesLoading"
                      :disabled="bankEditSaving || companiesLoading"
                    ></v-select>
                  </v-flex>
                  <v-flex xs12 sm4 class="pl-sm-2">
                    <v-text-field
                      v-model="bankEditModel.ibanIdentifier"
                      label="IBAN Belirteci (3 Harf)"
                      outlined
                      dense
                      maxlength="3"
                      :disabled="bankEditSaving"
                    ></v-text-field>
                  </v-flex>
                </v-layout>

                <v-layout wrap>
                  <v-flex xs12 sm4 class="pr-sm-2">
                    <v-text-field
                      v-model="bankEditModel.bankName"
                      label="Banka Adı"
                      outlined
                      dense
                      :disabled="bankEditSaving"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm4 class="px-sm-2">
                    <v-select
                      v-model="bankEditModel.accountPurityType"
                      :items="purityOptions"
                      item-text="text"
                      item-value="value"
                      label="Hesap Milyem Türü"
                      outlined
                      dense
                      clearable
                      :disabled="bankEditSaving"
                    ></v-select>
                  </v-flex>
                  <v-flex xs12 sm4 class="pl-sm-2">
                    <v-select
                      v-model="bankEditModel.status"
                      :items="bankStatusOptions"
                      item-text="text"
                      item-value="value"
                      label="Durum"
                      outlined
                      dense
                      :disabled="bankEditSaving"
                    ></v-select>
                  </v-flex>
                </v-layout>

                <v-layout wrap>
                  <v-flex xs12 sm6 class="pr-sm-2 ">
                    <v-text-field
                      class="bank-edit-bold-label"
                      v-model.number="bankEditModel.goldAmountInGrams"
                      label="Altın (gr)"
                      type="number"
                      step="0.01"
                      min="0"
                      outlined
                      dense
                      clearable
                      :disabled="bankEditSaving"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6 class="pl-sm-2">
                    <v-text-field
                      class="bank-edit-bold-label"
                      v-model.number="bankEditModel.cashAmount"
                      label="Nakit (TL)"
                      type="number"
                      step="0.01"
                      min="0"
                      outlined
                      dense
                      clearable
                      :disabled="bankEditSaving"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-card-text>
            </v-card>
          </v-container>
        </v-card-text>

        <v-divider></v-divider>
        <v-card-actions class="pa-4">
          <v-spacer></v-spacer>
          <v-btn color="grey" text @click="closeBankEditDialog" class="px-4" :disabled="bankEditSaving || companiesLoading">
            <v-icon left>close</v-icon>
            İptal
          </v-btn>
          <v-btn color="primary" depressed class="white--text px-4" :loading="bankEditSaving" :disabled="companiesLoading" @click="submitBankEdit">
            <v-icon left>check</v-icon>
            Kaydet
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="buyGoldDialog" max-width="720px" persistent>
      <v-card class="bank-modal">
        <v-card-title class="headline white--text amber darken-2 elevation-2">
          <v-icon left color="white" size="28">grain</v-icon>
          <span class="font-weight-bold">Altın Alımı</span>
          <v-spacer></v-spacer>
          <v-btn icon dark @click="buyGoldDialog = false" :disabled="buyGoldSaving || receiptUploading">
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text class="pa-5">
          <v-container grid-list-md>
            <v-card class="mb-4 modern-card" outlined>
              <v-card-title class="subtitle-1 amber--text text--darken-2 py-2">
                <v-icon left color="amber darken-2">account_balance</v-icon>
                Banka Bilgileri
              </v-card-title>
              <v-divider></v-divider>
              <v-card-text>
                <div class="body-2 font-weight-medium">{{ selectedBank ? selectedBank.bankName : '' }}</div>
              </v-card-text>
            </v-card>

            <v-card class="mb-4 modern-card" outlined>
              <v-card-title class="subtitle-1 amber--text text--darken-2 py-2">
                <v-icon left color="amber darken-2">payments</v-icon>
                İşlem Bilgileri
              </v-card-title>
              <v-divider></v-divider>
              <v-card-text>
                <v-layout wrap>
                  <v-flex xs12 sm6 class="pr-sm-2">
                    <v-text-field
                      v-model.number="buyGoldPayment"
                      label="Ödeme (TL)"
                      type="number"
                      step="0.01"
                      min="0"
                      outlined
                      dense
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6 class="pl-sm-2">
                    <v-text-field
                      v-model.number="buyGoldGram"
                      label="Gram"
                      type="number"
                      step="0.01"
                      min="0"
                      outlined
                      dense
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-card-text>
            </v-card>

            <v-card class="mb-2 receipt-shell" outlined>
              <div class="receipt-header">
                <div class="receipt-header-left">
                  <div class="receipt-icon">
                    <v-icon color="amber darken-2" size="22">receipt_long</v-icon>
                  </div>
                  <div>
                    <div class="receipt-title">Dekont</div>
                    <div class="receipt-subtitle">İsteğe bağlı</div>
                  </div>
                </div>
                <div v-if="buyGoldReceiptUrl" class="receipt-count-pill">
                  1 dekont yüklü
                </div>
              </div>
              <div class="receipt-body">
                <div class="receipt-dropzone" @click="triggerReceiptInput('buyGold')">
                  <div class="receipt-dropzone-icon">
                    <v-icon color="white" size="28">cloud_upload</v-icon>
                  </div>
                  <div class="receipt-dropzone-title">
                    {{ receiptUploading && receiptTarget === 'buyGold' ? 'YÜKLENİYOR' : 'DEKONT YÜKLE' }}
                  </div>
                  <div class="receipt-dropzone-desc">PDF, JPG, PNG</div>
                </div>
                <div v-if="buyGoldReceiptUrl" class="receipt-single mt-4">
                  <div class="receipt-single-name" :title="getReceiptFileName(buyGoldReceiptFileKey)">
                    {{ getReceiptFileName(buyGoldReceiptFileKey) }}
                  </div>
                  <div class="receipt-single-actions">
                    <v-btn small class="receipt-open-btn" @click.stop="copyText(buyGoldReceiptUrl)" :disabled="receiptUploading">
                      KOPYALA
                    </v-btn>
                    <v-btn small class="receipt-open-btn" @click.stop="openUrl(buyGoldReceiptUrl)" :disabled="receiptUploading">
                      AÇ
                    </v-btn>
                    <v-btn small color="error" text @click.stop="clearReceipt('buyGold')" :disabled="receiptUploading">
                      KALDIR
                    </v-btn>
                  </div>
                </div>
              </div>
            </v-card>
          </v-container>
        </v-card-text>

        <v-divider></v-divider>
        <v-card-actions class="pa-4">
          <v-spacer></v-spacer>
          <v-btn color="grey" text @click="buyGoldDialog = false" class="px-4" :disabled="buyGoldSaving || receiptUploading">
            <v-icon left>close</v-icon>
            İptal
          </v-btn>
          <v-btn color="amber darken-2" depressed class="white--text px-4" :loading="buyGoldSaving" :disabled="receiptUploading" @click="submitBuyGold">
            <v-icon left>check</v-icon>
            Kaydet
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="transferDialog" max-width="720px" persistent>
      <v-card class="bank-modal">
        <v-card-title class="headline white--text success elevation-2">
          <v-icon left color="white" size="28">swap_horiz</v-icon>
          <span class="font-weight-bold">Para Transfer</span>
          <v-spacer></v-spacer>
          <v-btn icon dark @click="transferDialog = false" :disabled="transferSaving || receiptUploading">
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text class="pa-4">
          <v-container grid-list-md>
            <v-card class="mb-4 modern-card" outlined>
              <v-card-title class="subtitle-1 success--text py-2">
                <v-icon left color="success">account_balance</v-icon>
                Gönderen Banka
              </v-card-title>
              <v-divider></v-divider>
              <v-card-text>
                <div class="body-2 font-weight-medium">{{ selectedBank ? selectedBank.bankName : '' }}</div>
              </v-card-text>
            </v-card>

            <v-card class="mb-4 modern-card" outlined>
              <v-card-title class="subtitle-1 success--text py-2">
                <v-icon left color="success">account_balance_wallet</v-icon>
                Transfer Bilgileri
              </v-card-title>
              <v-divider></v-divider>
              <v-card-text>
                <v-layout wrap>
                  <v-flex xs12>
                    <v-select
                      v-model="transferToBankName"
                      :items="transferTargetBankOptions"
                      label="Hedef Banka"
                      outlined
                      dense
                      clearable
                    ></v-select>
                  </v-flex>
                  <v-flex xs12 sm6 class="pr-sm-2">
                    <v-text-field
                      v-model.number="transferAmount"
                      label="Tutar (TL)"
                      type="number"
                      step="0.01"
                      min="0"
                      outlined
                      dense
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6 class="pl-sm-2">
                    <v-text-field
                      v-model.number="transferFee"
                      label="Transfer Ücreti (TL)"
                      type="number"
                      step="0.01"
                      min="0"
                      outlined
                      dense
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-card-text>
            </v-card>

            <v-card class="mb-2 receipt-shell" outlined>
              <div class="receipt-header">
                <div class="receipt-header-left">
                  <div class="receipt-icon">
                    <v-icon color="success" size="22">receipt_long</v-icon>
                  </div>
                  <div>
                    <div class="receipt-title">Dekont</div>
                    <div class="receipt-subtitle">İsteğe bağlı</div>
                  </div>
                </div>
                <div v-if="transferReceiptUrl" class="receipt-count-pill">
                  1 dekont yüklü
                </div>
              </div>
              <div class="receipt-body">
                <div class="receipt-dropzone" @click="triggerReceiptInput('transfer')">
                  <div class="receipt-dropzone-icon">
                    <v-icon color="white" size="28">cloud_upload</v-icon>
                  </div>
                  <div class="receipt-dropzone-title">
                    {{ receiptUploading && receiptTarget === 'transfer' ? 'YÜKLENİYOR' : 'DEKONT YÜKLE' }}
                  </div>
                  <div class="receipt-dropzone-desc">PDF, JPG, PNG</div>
                </div>
                <div v-if="transferReceiptUrl" class="receipt-single mt-4">
                  <div class="receipt-single-name" :title="getReceiptFileName(transferReceiptFileKey)">
                    {{ getReceiptFileName(transferReceiptFileKey) }}
                  </div>
                  <div class="receipt-single-actions">
                    <v-btn small class="receipt-open-btn" @click.stop="copyText(transferReceiptUrl)" :disabled="receiptUploading">
                      KOPYALA
                    </v-btn>
                    <v-btn small class="receipt-open-btn" @click.stop="openUrl(transferReceiptUrl)" :disabled="receiptUploading">
                      AÇ
                    </v-btn>
                    <v-btn small color="error" text @click.stop="clearReceipt('transfer')" :disabled="receiptUploading">
                      KALDIR
                    </v-btn>
                  </div>
                </div>
              </div>
            </v-card>
          </v-container>
        </v-card-text>

        <v-divider></v-divider>
        <v-card-actions class="pa-4">
          <v-spacer></v-spacer>
          <v-btn color="grey" text @click="transferDialog = false" class="px-4" :disabled="transferSaving || receiptUploading">
            <v-icon left>close</v-icon>
            İptal
          </v-btn>
          <v-btn color="success" depressed class="white--text px-4" :loading="transferSaving" :disabled="receiptUploading" @click="submitTransfer">
            <v-icon left>check</v-icon>
            Kaydet
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="goldTransferDialog" max-width="720px" persistent>
      <v-card class="bank-modal">
        <v-card-title class="headline white--text amber darken-2 elevation-2">
          <v-icon left color="white" size="28">grain</v-icon>
          <span class="font-weight-bold">Altın Transferi</span>
          <v-spacer></v-spacer>
          <v-btn icon dark @click="goldTransferDialog = false" :disabled="goldTransferSaving || receiptUploading">
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text class="pa-4">
          <v-container grid-list-md>
            <v-card class="mb-4 modern-card" outlined>
              <v-card-title class="subtitle-1 amber--text text--darken-2 py-2">
                <v-icon left color="amber darken-2">account_balance</v-icon>
                Gönderen Banka
              </v-card-title>
              <v-divider></v-divider>
              <v-card-text>
                <div class="body-2 font-weight-medium">{{ selectedBank ? selectedBank.bankName : '' }}</div>
              </v-card-text>
            </v-card>

            <v-card class="mb-4 modern-card" outlined>
              <v-card-title class="subtitle-1 amber--text text--darken-2 py-2">
                <v-icon left color="amber darken-2">swap_horiz</v-icon>
                Transfer Bilgileri
              </v-card-title>
              <v-divider></v-divider>
              <v-card-text>
                <v-layout wrap>
                  <v-flex xs12>
                    <v-select
                      v-model="goldTransferToBankName"
                      :items="transferTargetBankOptions"
                      label="Hedef Banka"
                      outlined
                      dense
                      clearable
                    ></v-select>
                  </v-flex>
                  <v-flex xs12 sm6 class="pr-sm-2">
                    <v-text-field
                      v-model.number="goldTransferGram"
                      label="Gram"
                      type="number"
                      step="0.01"
                      min="0"
                      outlined
                      dense
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6 class="pl-sm-2">
                    <v-text-field
                      v-model.number="goldTransferFee"
                      label="Transfer Ücreti (TL)"
                      type="number"
                      step="0.01"
                      min="0"
                      outlined
                      dense
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-card-text>
            </v-card>

            <v-card class="mb-2 receipt-shell" outlined>
              <div class="receipt-header">
                <div class="receipt-header-left">
                  <div class="receipt-icon">
                    <v-icon color="amber darken-2" size="22">receipt_long</v-icon>
                  </div>
                  <div>
                    <div class="receipt-title">Dekont</div>
                    <div class="receipt-subtitle">İsteğe bağlı</div>
                  </div>
                </div>
                <div v-if="goldTransferReceiptUrl" class="receipt-count-pill">
                  1 dekont yüklü
                </div>
              </div>
              <div class="receipt-body">
                <div class="receipt-dropzone" @click="triggerReceiptInput('goldTransfer')">
                  <div class="receipt-dropzone-icon">
                    <v-icon color="white" size="28">cloud_upload</v-icon>
                  </div>
                  <div class="receipt-dropzone-title">
                    {{ receiptUploading && receiptTarget === 'goldTransfer' ? 'YÜKLENİYOR' : 'DEKONT YÜKLE' }}
                  </div>
                  <div class="receipt-dropzone-desc">PDF, JPG, PNG</div>
                </div>
                <div v-if="goldTransferReceiptUrl" class="receipt-single mt-4">
                  <div class="receipt-single-name" :title="getReceiptFileName(goldTransferReceiptFileKey)">
                    {{ getReceiptFileName(goldTransferReceiptFileKey) }}
                  </div>
                  <div class="receipt-single-actions">
                    <v-btn small class="receipt-open-btn" @click.stop="copyText(goldTransferReceiptUrl)" :disabled="receiptUploading">
                      KOPYALA
                    </v-btn>
                    <v-btn small class="receipt-open-btn" @click.stop="openUrl(goldTransferReceiptUrl)" :disabled="receiptUploading">
                      AÇ
                    </v-btn>
                    <v-btn small color="error" text @click.stop="clearReceipt('goldTransfer')" :disabled="receiptUploading">
                      KALDIR
                    </v-btn>
                  </div>
                </div>
              </div>
            </v-card>
          </v-container>
        </v-card-text>

        <v-divider></v-divider>
        <v-card-actions class="pa-4">
          <v-spacer></v-spacer>
          <v-btn color="grey" text @click="goldTransferDialog = false" class="px-4" :disabled="goldTransferSaving || receiptUploading">
            <v-icon left>close</v-icon>
            İptal
          </v-btn>
          <v-btn color="amber darken-2" depressed class="white--text px-4" :loading="goldTransferSaving" :disabled="receiptUploading" @click="submitGoldTransfer">
            <v-icon left>check</v-icon>
            Kaydet
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="externalPaymentsDialog" max-width="720px" persistent>
      <v-card class="bank-modal">
        <v-card-title class="headline white--text indigo elevation-2">
          <v-icon left color="white" size="28">payments</v-icon>
          <span class="font-weight-bold">Dış Ödemeler</span>
          <v-spacer></v-spacer>
          <v-btn icon dark @click="externalPaymentsDialog = false" :disabled="externalPaymentsSaving">
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text class="pa-4">
          <v-container grid-list-md>
            <v-card class="mb-4 modern-card" outlined>
              <v-card-title class="subtitle-1 indigo--text py-2">
                <v-icon left color="indigo">account_balance</v-icon>
                Banka Bilgileri
              </v-card-title>
              <v-divider></v-divider>
              <v-card-text>
                <div class="body-2 font-weight-medium">{{ selectedBank ? selectedBank.bankName : '' }}</div>
              </v-card-text>
            </v-card>

            <v-card class="mb-4 modern-card" outlined>
              <v-card-title class="subtitle-1 indigo--text py-2">
                <v-icon left color="indigo">tune</v-icon>
                İşlem Bilgileri
              </v-card-title>
              <v-divider></v-divider>
              <v-card-text>
                <v-layout wrap>
                  <v-flex xs12 sm6 class="pr-sm-2">
                    <v-text-field
                      v-model.number="externalPaymentAmount"
                      label="Ödeme (TL)"
                      type="number"
                      step="0.01"
                      min="0"
                      outlined
                      dense
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6 class="pl-sm-2">
                    <v-select
                      v-model="externalPaymentType"
                      :items="externalPaymentTypes"
                      item-text="text"
                      item-value="value"
                      label="Ödeme Türü"
                      outlined
                      dense
                    ></v-select>
                  </v-flex>
                  <v-flex v-if="externalPaymentType === 'DIGER'" xs12 class="mt-2">
                    <v-text-field
                      v-model="externalPaymentTypeOtherText"
                      label="Diğer (Açıklama)"
                      type="text"
                      outlined
                      dense
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-card-text>
            </v-card>
          </v-container>
        </v-card-text>

        <v-divider></v-divider>
        <v-card-actions class="pa-4">
          <v-spacer></v-spacer>
          <v-btn color="grey" text @click="externalPaymentsDialog = false" class="px-4" :disabled="externalPaymentsSaving">
            <v-icon left>close</v-icon>
            İptal
          </v-btn>
          <v-btn color="indigo" depressed class="white--text px-4" :loading="externalPaymentsSaving" @click="submitExternalPayments">
            <v-icon left>check</v-icon>
            Kaydet
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="incomingPaymentDialog" max-width="720px" persistent>
      <v-card class="bank-modal">
        <v-card-title class="headline white--text cyan darken-2 elevation-2">
          <v-icon left color="white" size="28">add_circle</v-icon>
          <span class="font-weight-bold">Gelen Ödeme</span>
          <v-spacer></v-spacer>
          <v-btn icon dark @click="incomingPaymentDialog = false" :disabled="incomingPaymentSaving">
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text class="pa-4">
          <v-container grid-list-md>
            <v-card class="mb-4 modern-card" outlined>
              <v-card-title class="subtitle-1 cyan--text text--darken-2 py-2">
                <v-icon left color="cyan darken-2">account_balance</v-icon>
                Banka Bilgileri
              </v-card-title>
              <v-divider></v-divider>
              <v-card-text>
                <div class="body-2 font-weight-medium">{{ selectedBank ? selectedBank.bankName : '' }}</div>
              </v-card-text>
            </v-card>

            <v-card class="mb-4 modern-card" outlined>
              <v-card-title class="subtitle-1 cyan--text text--darken-2 py-2">
                <v-icon left color="cyan darken-2">tune</v-icon>
                İşlem Bilgileri
              </v-card-title>
              <v-divider></v-divider>
              <v-card-text>
                <v-layout wrap>
                  <v-flex xs12 sm6 class="pr-sm-2">
                    <v-text-field
                      v-model.number="incomingPaymentAmount"
                      label="Tutar (TL)"
                      type="number"
                      step="0.01"
                      min="0"
                      outlined
                      dense
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-card-text>
            </v-card>
          </v-container>
        </v-card-text>

        <v-divider></v-divider>
        <v-card-actions class="pa-4">
          <v-spacer></v-spacer>
          <v-btn color="grey" text @click="incomingPaymentDialog = false" class="px-4" :disabled="incomingPaymentSaving">
            <v-icon left>close</v-icon>
            İptal
          </v-btn>
          <v-btn color="cyan darken-2" depressed class="white--text px-4" :loading="incomingPaymentSaving" @click="submitIncomingPayment">
            <v-icon left>check</v-icon>
            Kaydet
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <input
      ref="receiptFileInput"
      type="file"
      accept="application/pdf,image/*"
      style="display: none"
      @change="onReceiptFileSelected"
    />
  </div>
</template>

<script>
import moment from 'moment';
import Api from "@/api/baseApi";
import axios from "axios";
import activityLogsApi from "@/api/activityLogs";
import partnerBanksApi from "@/api/partnerBanks";
import companiesApi from "@/api/companies";
import { userService } from '@/_services/user.service';

export default {
  data() {
    return {
      activeTab: 0,
      search: '',
      statusFilter: '',
      tenantFilter: '',
      companyFilter: '',
      tenantFilterOptions: [
        { text: 'Tümü', value: '' },
        { text: 'ALTINDAFIRSAT', value: 1 },
        { text: 'E-ALTIN', value: 2 }
      ],
      tenantOptions: [
        { tenantId: 1, tenantName: 'ALTINDAFIRSAT' },
        { tenantId: 2, tenantName: 'E-ALTIN' }
      ],
      purityOptions: [
        { text: '1000 Milyem', value: 1000 },
        { text: '995 Milyem', value: 995 },
        { text: '916 Milyem', value: 916 }
      ],
      bankStatusOptions: [
        { text: 'Aktif', value: 'ACTIVE' },
        { text: 'Pasif', value: 'PASSIVE' }
      ],
      companiesLoading: false,
      companies: [],
      loading: false,
      deleteDialog: false,
      deleting: false,
      bankToDelete: null,
      bankEditDialog: false,
      bankEditSaving: false,
      bankEditIsNew: false,
      bankEditModel: {
        id: null,
        tenantId: null,
        companyId: null,
        ibanIdentifier: '',
        bankName: '',
        accountPurityType: null,
        goldAmountInGrams: null,
        cashAmount: null,
        status: 'ACTIVE'
      },
      buyGoldDialog: false,
      buyGoldSaving: false,
      buyGoldPayment: null,
      buyGoldGram: null,
      buyGoldReceiptFileKey: '',
      buyGoldReceiptUrl: '',
      transferDialog: false,
      transferSaving: false,
      transferToBankName: '',
      transferAmount: null,
      transferFee: 0,
      transferReceiptFileKey: '',
      transferReceiptUrl: '',
      goldTransferDialog: false,
      goldTransferSaving: false,
      goldTransferToBankName: '',
      goldTransferGram: null,
      goldTransferFee: 0,
      goldTransferReceiptFileKey: '',
      goldTransferReceiptUrl: '',
      externalPaymentsDialog: false,
      externalPaymentsSaving: false,
      externalPaymentAmount: null,
      externalPaymentType: null,
      externalPaymentTypeOtherText: '',
      externalPaymentTypes: [
        { value: 'SGK', text: 'SGK' },
        { value: 'BANKA_KREDISI', text: 'Banka Kredisi' },
        { value: 'MAASLAR', text: 'Maaşlar' },
        { value: 'GONDERIM_UCRETI', text: 'Gönderim Ücreti' },
        { value: 'KDV', text: 'KDV' },
        { value: 'UYUMSOFT', text: 'Uyumsoft' },
        { value: 'KREDI_KARTI', text: 'Kredi Kartı' },
        { value: 'EK_HESAP_ISLETIM_UCRETI', text: 'Ek Hesap İşletim Ücreti' },
        { value: 'ONUR_BEY', text: 'Onur Bey' },
        { value: 'IDIA', text: 'Idia' },
        { value: 'GOLDVION', text: 'Goldvion' },
        { value: 'DIGER', text: 'Diğer' },
      ],
      incomingPaymentDialog: false,
      incomingPaymentSaving: false,
      incomingPaymentAmount: null,
      receiptUploading: false,
      receiptTarget: '',
      selectedBank: null,
      logsDate: moment().format('YYYY-MM-DD'),
      goldLogsDateMenu: false,
      cashLogsDateMenu: false,
      goldTransferLogsDateMenu: false,
      externalLogsDateMenu: false,
      goldBuyLogs: [],
      goldLogsLoading: false,
      cashTransferLogs: [],
      cashLogsLoading: false,
      goldTransferLogs: [],
      goldTransferLogsLoading: false,
      externalPaymentLogs: [],
      externalLogsLoading: false,
      expectedPaymentCheckLists: [],
      expectedPaymentLoading: false,
      dailyOverviewLoading: false,
      dailyPurchasedGold: [],
      dailyGoldStock: null,
      dailySummaryRowsPerPage: 10,
      dailySummaryPage: 1,
      banksRowsPerPage: 10,
      banksPage: 1,
      goldLogsRowsPerPage: 10,
      goldLogsPage: 1,
      cashLogsRowsPerPage: 10,
      cashLogsPage: 1,
      goldTransferLogsRowsPerPage: 10,
      goldTransferLogsPage: 1,
      externalLogsRowsPerPage: 10,
      externalLogsPage: 1,
      externalLogsCompanyId: "",
      externalLogsSearch: "",
      dailySummaryCompanyFilter: "",
      goldLogsCompanyFilter: "",
      cashLogsCompanyFilter: "",
      goldTransferLogsCompanyFilter: "",
      snapshotDetailCompanyFilter: "",
      usersMap: {},
      bankUsersMap: {},
      bankCompanyMap: {},
      snapshots: [],
      snapshotsLoading: false,
      snapshotsRowsPerPage: 10,
      snapshotsPage: 1,
      snapshotDateFilter: moment().subtract(1, 'days').format('YYYY-MM-DD'),
      snapshotDateMenu: false,
      snapshotDetailDialog: false,
      snapshotDetailData: null,
      snapshotDetailDate: '',
      statusOptions: [
        { text: 'Tümü', value: '' },
        { text: 'Aktif', value: 'ACTIVE' },
        { text: 'Pasif', value: 'PASSIVE' }
      ],
      logHeaders: [
        { text: 'Kayıt', value: 'message', sortable: false, align: 'left' },
        { text: 'Dekont', value: 'extraData', sortable: false, align: 'center', width: '180px' },
      ],
      headers: [
        { text: 'Tenant', value: 'tenantId', sortable: true },
        { text: 'IBAN Belirteci', value: 'ibanIdentifier', sortable: true },
        { text: 'Banka Adı', value: 'bankName', sortable: true },
        { text: 'Hesap Milyem Türü', value: 'accountPurityType', sortable: true },
        { text: 'Altın Miktarı (Gram)', value: 'goldAmountInGrams', sortable: true },
        { text: 'Nakit Tutarı', value: 'cashAmount', sortable: true },
        { text: 'Durum', value: 'status', sortable: true },
        { text: 'Oluşturma Tarihi', value: 'createdDate', sortable: true },
        { text: 'İşlemler', value: 'actions', sortable: false, align: 'center' }
      ],
      dailyPurchasedHeaders: [
        { text: 'Banka', value: 'bankName', sortable: true },
        { text: 'Toplam Gram', value: 'totalGram', sortable: true },
        { text: 'Toplam Ödeme', value: 'totalPayment', sortable: true },
        { text: 'Ortalama (TL/gr)', value: 'avgTlPerGr', sortable: false },
      ]
    };
  },

  computed: {
    partnerBanks() {
      return this.$store.state.partnerBanks.all || [];
    },
    companiesById() {
      const map = {};
      (this.companies || []).forEach((c) => {
        if (c && c.id) map[c.id] = c;
      });
      return map;
    },
    paginatedBanks() {
      const list = this.partnerBanks || [];
      const per = this.banksRowsPerPage || 10;
      const totalP = Math.max(1, Math.ceil(list.length / per));
      const page = Math.min(totalP, Math.max(1, this.banksPage || 1));
      const start = (page - 1) * per;
      return list.slice(start, start + per);
    },
    banksTotalPages() {
      const list = this.partnerBanks || [];
      const per = this.banksRowsPerPage || 10;
      return Math.max(1, Math.ceil(list.length / per));
    },
    banksPaginationInfo() {
      const list = this.partnerBanks || [];
      const per = this.banksRowsPerPage || 10;
      const totalP = Math.max(1, Math.ceil(list.length / per));
      const page = Math.min(totalP, Math.max(1, this.banksPage || 1));
      const start = list.length === 0 ? 0 : (page - 1) * per + 1;
      const end = Math.min(page * per, list.length);
      const total = list.length;
      if (total === 0) return '0-0 de 0';
      return `${start}-${end} de ${total}`;
    },
    filteredGoldBuyLogs() {
      const list = this.goldBuyLogs || [];
      const selected = this.goldLogsCompanyFilter ? Number(this.goldLogsCompanyFilter) : null;
      if (!selected) return list;
      return list.filter((l) => {
        const obj = this.getMessageObject(l && l.message ? l.message : null);
        if (!obj) return false;
        const cidRaw = (obj.companyId !== undefined && obj.companyId !== null) ? obj.companyId : obj.CompanyId;
        const cid = Number(cidRaw);
        return Number.isFinite(cid) && cid === selected;
      });
    },
    paginatedGoldLogs() {
      const list = this.filteredGoldBuyLogs || [];
      const per = this.goldLogsRowsPerPage || 10;
      const totalP = Math.max(1, Math.ceil(list.length / per));
      const page = Math.min(totalP, Math.max(1, this.goldLogsPage || 1));
      const start = (page - 1) * per;
      return list.slice(start, start + per);
    },
    goldLogsTotalPages() {
      const list = this.filteredGoldBuyLogs || [];
      const per = this.goldLogsRowsPerPage || 10;
      return Math.max(1, Math.ceil(list.length / per));
    },
    goldLogsPaginationInfo() {
      const list = this.filteredGoldBuyLogs || [];
      const per = this.goldLogsRowsPerPage || 10;
      const totalP = Math.max(1, Math.ceil(list.length / per));
      const page = Math.min(totalP, Math.max(1, this.goldLogsPage || 1));
      const start = list.length === 0 ? 0 : (page - 1) * per + 1;
      const end = Math.min(page * per, list.length);
      const total = list.length;
      if (total === 0) return '0-0 de 0';
      return `${start}-${end} de ${total}`;
    },
    filteredCashTransferLogs() {
      const list = this.cashTransferLogs || [];
      const selected = this.cashLogsCompanyFilter ? Number(this.cashLogsCompanyFilter) : null;
      if (!selected) return list;
      return list.filter((l) => {
        const obj = this.getMessageObject(l && l.message ? l.message : null);
        if (!obj) return false;
        const cidRaw = (obj.companyId !== undefined && obj.companyId !== null) ? obj.companyId : obj.CompanyId;
        const cid = Number(cidRaw);
        return Number.isFinite(cid) && cid === selected;
      });
    },
    paginatedCashLogs() {
      const list = this.filteredCashTransferLogs || [];
      const per = this.cashLogsRowsPerPage || 10;
      const totalP = Math.max(1, Math.ceil(list.length / per));
      const page = Math.min(totalP, Math.max(1, this.cashLogsPage || 1));
      const start = (page - 1) * per;
      return list.slice(start, start + per);
    },
    cashLogsTotalPages() {
      const list = this.filteredCashTransferLogs || [];
      const per = this.cashLogsRowsPerPage || 10;
      return Math.max(1, Math.ceil(list.length / per));
    },
    cashLogsPaginationInfo() {
      const list = this.filteredCashTransferLogs || [];
      const per = this.cashLogsRowsPerPage || 10;
      const totalP = Math.max(1, Math.ceil(list.length / per));
      const page = Math.min(totalP, Math.max(1, this.cashLogsPage || 1));
      const start = list.length === 0 ? 0 : (page - 1) * per + 1;
      const end = Math.min(page * per, list.length);
      const total = list.length;
      if (total === 0) return '0-0 de 0';
      return `${start}-${end} de ${total}`;
    },
    filteredGoldTransferLogs() {
      const list = this.goldTransferLogs || [];
      const selected = this.goldTransferLogsCompanyFilter ? Number(this.goldTransferLogsCompanyFilter) : null;
      if (!selected) return list;
      return list.filter((l) => {
        const obj = this.getMessageObject(l && l.message ? l.message : null);
        if (!obj) return false;
        const cidRaw = (obj.companyId !== undefined && obj.companyId !== null) ? obj.companyId : obj.CompanyId;
        const cid = Number(cidRaw);
        return Number.isFinite(cid) && cid === selected;
      });
    },
    paginatedGoldTransferLogs() {
      const list = this.filteredGoldTransferLogs || [];
      const per = this.goldTransferLogsRowsPerPage || 10;
      const totalP = Math.max(1, Math.ceil(list.length / per));
      const page = Math.min(totalP, Math.max(1, this.goldTransferLogsPage || 1));
      const start = (page - 1) * per;
      return list.slice(start, start + per);
    },
    goldTransferLogsTotalPages() {
      const list = this.filteredGoldTransferLogs || [];
      const per = this.goldTransferLogsRowsPerPage || 10;
      return Math.max(1, Math.ceil(list.length / per));
    },
    goldTransferLogsPaginationInfo() {
      const list = this.filteredGoldTransferLogs || [];
      const per = this.goldTransferLogsRowsPerPage || 10;
      const totalP = Math.max(1, Math.ceil(list.length / per));
      const page = Math.min(totalP, Math.max(1, this.goldTransferLogsPage || 1));
      const start = list.length === 0 ? 0 : (page - 1) * per + 1;
      const end = Math.min(page * per, list.length);
      const total = list.length;
      if (total === 0) return '0-0 de 0';
      return `${start}-${end} de ${total}`;
    },
    filteredExternalPaymentLogs() {
      let list = this.externalPaymentLogs || [];
      const selected = this.externalLogsCompanyId ? Number(this.externalLogsCompanyId) : null;
      if (selected) {
        list = list.filter((l) => {
          const obj = this.getMessageObject(l && l.message ? l.message : null);
          if (!obj) return false;
          const cidRaw = (obj.companyId !== undefined && obj.companyId !== null) ? obj.companyId : obj.CompanyId;
          const cid = Number(cidRaw);
          return Number.isFinite(cid) && cid === selected;
        });
      }
      const search = (this.externalLogsSearch || '').toLowerCase().trim();
      if (!search) return list;
      return list.filter((l) => {
        const obj = this.getMessageObject(l && l.message ? l.message : null);
        if (!obj) return false;
        const bankName = (obj.bankName || obj.BankName || '').toLowerCase();
        const paymentType = (obj.paymentType || obj.PaymentType || '').toLowerCase();
        const payment = String(obj.payment || obj.Payment || '');
        const companyName = this.getExternalPaymentCompanyName(l.message).toLowerCase();
        return bankName.includes(search) || paymentType.includes(search) || payment.includes(search) || companyName.includes(search);
      });
    },
    paginatedExternalPaymentLogs() {
      const list = this.filteredExternalPaymentLogs || [];
      const per = this.externalLogsRowsPerPage || 10;
      const totalP = Math.max(1, Math.ceil(list.length / per));
      const page = Math.min(totalP, Math.max(1, this.externalLogsPage || 1));
      const start = (page - 1) * per;
      return list.slice(start, start + per);
    },
    externalLogsTotalPages() {
      const list = this.filteredExternalPaymentLogs || [];
      const per = this.externalLogsRowsPerPage || 10;
      return Math.max(1, Math.ceil(list.length / per));
    },
    externalLogsPaginationInfo() {
      const list = this.filteredExternalPaymentLogs || [];
      const per = this.externalLogsRowsPerPage || 10;
      const totalP = Math.max(1, Math.ceil(list.length / per));
      const page = Math.min(totalP, Math.max(1, this.externalLogsPage || 1));
      const start = list.length === 0 ? 0 : (page - 1) * per + 1;
      const end = Math.min(page * per, list.length);
      const total = list.length;
      if (total === 0) return '0-0 de 0';
      return `${start}-${end} de ${total}`;
    },
    filteredDailyPurchasedGold() {
      return this.dailyPurchasedGold || [];
    },
    paginatedDailyPurchased() {
      const list = this.filteredDailyPurchasedGold || [];
      const per = this.dailySummaryRowsPerPage || 10;
      const totalP = Math.max(1, Math.ceil(list.length / per));
      const page = Math.min(totalP, Math.max(1, this.dailySummaryPage || 1));
      const start = (page - 1) * per;
      return list.slice(start, start + per);
    },
    dailySummaryTotalPages() {
      const list = this.filteredDailyPurchasedGold || [];
      const per = this.dailySummaryRowsPerPage || 10;
      return Math.max(1, Math.ceil(list.length / per));
    },
    dailySummaryPaginationInfo() {
      const list = this.filteredDailyPurchasedGold || [];
      const per = this.dailySummaryRowsPerPage || 10;
      const totalP = Math.max(1, Math.ceil(list.length / per));
      const page = Math.min(totalP, Math.max(1, this.dailySummaryPage || 1));
      const start = list.length === 0 ? 0 : (page - 1) * per + 1;
      const end = Math.min(page * per, list.length);
      const total = list.length;
      if (total === 0) return '0-0 de 0';
      return `${start}-${end} de ${total}`;
    },
    transferTargetBankOptions() {
      const fromName = this.selectedBank ? this.selectedBank.bankName : '';
      const companyId = this.selectedBank ? this.selectedBank.companyId : null;
      return (this.partnerBanks || [])
        .filter((b) => b && b.bankName && b.bankName !== fromName && (companyId ? b.companyId === companyId : true))
        .map((b) => b.bankName)
        .filter((name, idx, arr) => arr.indexOf(name) === idx);
    },
    paginatedSnapshots() {
      const list = this.snapshots || [];
      const per = this.snapshotsRowsPerPage || 10;
      const totalP = Math.max(1, Math.ceil(list.length / per));
      const page = Math.min(totalP, Math.max(1, this.snapshotsPage || 1));
      const start = (page - 1) * per;
      return list.slice(start, start + per);
    },
    snapshotsTotalPages() {
      const list = this.snapshots || [];
      const per = this.snapshotsRowsPerPage || 10;
      return Math.max(1, Math.ceil(list.length / per));
    },
    snapshotsPaginationInfo() {
      const list = this.snapshots || [];
      const per = this.snapshotsRowsPerPage || 10;
      const totalP = Math.max(1, Math.ceil(list.length / per));
      const page = Math.min(totalP, Math.max(1, this.snapshotsPage || 1));
      const start = list.length === 0 ? 0 : (page - 1) * per + 1;
      const end = Math.min(page * per, list.length);
      const total = list.length;
      if (total === 0) return '0-0 de 0';
      return `${start}-${end} de ${total}`;
    },
    filteredSnapshotDetailData() {
      if (!this.snapshotDetailData || !this.snapshotDetailData.Snapshot) return [];
      const list = this.snapshotDetailData.Snapshot || [];
      const selected = this.snapshotDetailCompanyFilter ? Number(this.snapshotDetailCompanyFilter) : null;
      if (!selected) return list;
      return list.filter((bank) => {
        return bank && bank.CompanyId === selected;
      });
    },
  },
  watch: {
    dailySummaryCompanyFilter() {
      if (this.activeTab === 1) {
        this.loadDailyOverview();
      }
    },
  },

  methods: {
    onTabChanged() {
      if (this.activeTab === 1) this.loadDailyOverview();
      if (this.activeTab === 2) this.loadGoldBuyLogs();
      if (this.activeTab === 3) this.loadCashTransferLogs();
      if (this.activeTab === 4) this.loadGoldTransferLogs();
      if (this.activeTab === 5) this.loadExternalPaymentLogs();
      if (this.activeTab === 6) this.loadExpectedPaymentCheckLists();
      if (this.activeTab === 7) this.loadSnapshots();
    },

    refreshActiveLogs() {
      if (this.activeTab === 1) return this.loadDailyOverview();
      if (this.activeTab === 2) return this.loadGoldBuyLogs();
      if (this.activeTab === 3) return this.loadCashTransferLogs();
      if (this.activeTab === 4) return this.loadGoldTransferLogs();
      if (this.activeTab === 5) return this.loadExternalPaymentLogs();
      if (this.activeTab === 6) return this.loadExpectedPaymentCheckLists();
      if (this.activeTab === 7) return this.loadSnapshots();
    },

    async loadDailyOverview() {
      this.dailyOverviewLoading = true;
      try {
        const selectedCompanyId = this.dailySummaryCompanyFilter ? Number(this.dailySummaryCompanyFilter) : null;
        const [purchasedRes, stockRes, logsRes] = await Promise.all([
          partnerBanksApi.dailyPurchasedGoldGroupedByBank(selectedCompanyId),
          partnerBanksApi.calculateDailyGoldStock(selectedCompanyId),
          activityLogsApi.getActivityLogs({
            type: 1,
            subType: 101,
            date: this.logsDate,
          }),
        ]);

        const logsList = (logsRes && logsRes.data) ? logsRes.data : [];
        
        const groupedByBankAndCompany = {};
        logsList.forEach((log) => {
          const obj = this.getMessageObject(log.message);
          if (!obj) return;
          const bankName = obj.bankName ? String(obj.bankName).trim() : (obj.BankName ? String(obj.BankName).trim() : '');
          const companyIdRaw = (obj.companyId !== undefined && obj.companyId !== null) ? obj.companyId : obj.CompanyId;
          const companyId = companyIdRaw ? Number(companyIdRaw) : null;
          const purchasedGramsRaw = (obj.purchasedGrams !== undefined && obj.purchasedGrams !== null) ? obj.purchasedGrams : obj.PurchasedGrams;
          const paymentRaw = (obj.payment !== undefined && obj.payment !== null) ? obj.payment : obj.Payment;
          const purchasedGrams = purchasedGramsRaw ? Number(purchasedGramsRaw) : 0;
          const payment = paymentRaw ? Number(paymentRaw) : 0;
          
          if (!bankName || (!companyId || !Number.isFinite(companyId))) return;
          
          const key = `${bankName}_${companyId}`;
          if (!groupedByBankAndCompany[key]) {
            groupedByBankAndCompany[key] = {
              bankName: bankName,
              companyId: companyId,
              totalGram: 0,
              totalPayment: 0,
            };
          }
          groupedByBankAndCompany[key].totalGram += purchasedGrams;
          groupedByBankAndCompany[key].totalPayment += payment;
        });
        
        if (selectedCompanyId) {
          this.dailyPurchasedGold = Object.values(groupedByBankAndCompany)
            .filter((item) => item.companyId === selectedCompanyId)
            .map((item) => ({
              bankName: item.bankName,
              totalGram: item.totalGram,
              totalPayment: item.totalPayment,
            }));
        } else {
          const groupedByBank = {};
          Object.values(groupedByBankAndCompany).forEach((item) => {
            if (!groupedByBank[item.bankName]) {
              groupedByBank[item.bankName] = {
                bankName: item.bankName,
                totalGram: 0,
                totalPayment: 0,
              };
            }
            groupedByBank[item.bankName].totalGram += item.totalGram;
            groupedByBank[item.bankName].totalPayment += item.totalPayment;
          });
          this.dailyPurchasedGold = Object.values(groupedByBank);
        }
        
        this.dailyGoldStock = (stockRes && stockRes.data) ? stockRes.data : null;
        await this.loadUsersForDailySummary();
      } catch (error) {
        this.dailyPurchasedGold = [];
        this.dailyGoldStock = null;
        this.$store.state.dialog = true;
        this.$store.state.message = "Günlük altın özeti alınamadı.";
      } finally {
        this.dailyOverviewLoading = false;
      }
    },
    async loadUsersForDailySummary() {
      if (!this.dailyPurchasedGold || !this.dailyPurchasedGold.length) return;
      const bankNames = new Set(this.dailyPurchasedGold.map((d) => d.bankName).filter(Boolean));
      if (bankNames.size === 0) return;
      try {
        const res = await activityLogsApi.getActivityLogs({
          type: 1,
          subType: 101,
          date: this.logsDate,
        });
        const list = (res && res.data) ? res.data : [];
        const bankUsers = {};
        const bankCompanies = {};
        list.forEach((log) => {
          const obj = this.getMessageObject(log.message);
          const bankName = obj
            ? (obj.bankName ? String(obj.bankName).trim() : (obj.BankName ? String(obj.BankName).trim() : ''))
            : '';
          const companyIdRaw = obj
            ? ((obj.companyId !== undefined && obj.companyId !== null) ? obj.companyId : obj.CompanyId)
            : null;
          const companyId = companyIdRaw ? Number(companyIdRaw) : null;
          if (bankName && bankNames.has(bankName)) {
            if (log.userId && Number.isFinite(log.userId) && log.userId > 0) {
              if (!bankUsers[bankName]) {
                bankUsers[bankName] = new Set();
              }
              bankUsers[bankName].add(log.userId);
            }
            if (companyId && Number.isFinite(companyId) && companyId > 0) {
              if (!bankCompanies[bankName]) {
                bankCompanies[bankName] = new Set();
              }
              bankCompanies[bankName].add(companyId);
            }
          }
        });
        const userIds = new Set();
        Object.values(bankUsers).forEach((userSet) => {
          userSet.forEach((uid) => userIds.add(uid));
        });
        if (userIds.size > 0) {
          const users = await userService.getAllWithoutTenants();
          if (users && Array.isArray(users)) {
            users.forEach((user) => {
              if (user && user.id && userIds.has(user.id)) {
                this.$set(this.usersMap, user.id, user.username || `Kullanıcı ${user.id}`);
              }
            });
          }
        }
        Object.keys(bankUsers).forEach((bankName) => {
          const userNames = Array.from(bankUsers[bankName])
            .map((uid) => this.usersMap[uid] || `Kullanıcı ${uid}`)
            .filter(Boolean);
          this.$set(this.bankUsersMap, bankName, userNames.join(', ') || '-');
        });
        Object.keys(bankCompanies).forEach((bankName) => {
          const companyIds = Array.from(bankCompanies[bankName]);
          this.$set(this.bankCompanyMap, bankName, companyIds);
        });
      } catch (e) {
        void e;
      }
    },
    getBankUsers(bankName) {
      if (!bankName) return '-';
      return this.bankUsersMap[bankName] || '-';
    },

    async loadGoldBuyLogs() {
      this.goldLogsLoading = true;
      try {
        const res = await activityLogsApi.getActivityLogs({
          type: 1,
          subType: 101,
          date: this.logsDate,
        });
        this.goldBuyLogs = (res && res.data) ? res.data : [];
        await this.loadUsersForLogs(this.goldBuyLogs);
      } catch (error) {
        this.goldBuyLogs = [];
        this.$store.state.dialog = true;
        this.$store.state.message = "Altın alımı kayıtları alınamadı.";
      } finally {
        this.goldLogsLoading = false;
      }
    },

    async loadCashTransferLogs() {
      this.cashLogsLoading = true;
      try {
        const res = await activityLogsApi.getActivityLogs({
          type: 1,
          subType: 102,
          date: this.logsDate,
        });
        this.cashTransferLogs = (res && res.data) ? res.data : [];
        await this.loadUsersForLogs(this.cashTransferLogs);
      } catch (error) {
        this.cashTransferLogs = [];
        this.$store.state.dialog = true;
        this.$store.state.message = "Nakit transfer kayıtları alınamadı.";
      } finally {
        this.cashLogsLoading = false;
      }
    },

    async loadGoldTransferLogs() {
      this.goldTransferLogsLoading = true;
      try {
        const res = await activityLogsApi.getActivityLogs({
          type: 1,
          subType: 106,
          date: this.logsDate,
        });
        this.goldTransferLogs = (res && res.data) ? res.data : [];
        await this.loadUsersForLogs(this.goldTransferLogs);
      } catch (error) {
        this.goldTransferLogs = [];
        this.$store.state.dialog = true;
        this.$store.state.message = "Altın transfer kayıtları alınamadı.";
      } finally {
        this.goldTransferLogsLoading = false;
      }
    },

    async loadExternalPaymentLogs() {
      this.externalLogsLoading = true;
      try {
        if (!this.companies || !this.companies.length) {
          await this.loadCompanies();
        }
        const res = await partnerBanksApi.getExternalPaymentLogs(this.logsDate);
        this.externalPaymentLogs = (res && res.data) ? res.data : [];
        await this.loadUsersForLogs(this.externalPaymentLogs);
      } catch (e) {
        this.externalPaymentLogs = [];
      } finally {
        this.externalLogsLoading = false;
      }
    },

    getExpectedPaymentValue(item) {
      if (!item) return 0;
      return (item.expectedPayment !== undefined && item.expectedPayment !== null) ? item.expectedPayment : (item.ExpectedPayment || 0);
    },
    getIncomingPaymentValue(item) {
      if (!item) return 0;
      return (item.incomingPayment !== undefined && item.incomingPayment !== null) ? item.incomingPayment : (item.IncomingPayment || 0);
    },
    getExpectedPaymentDeltaValue(item) {
      return (this.getIncomingPaymentValue(item) || 0) - (this.getExpectedPaymentValue(item) || 0);
    },
    async loadExpectedPaymentCheckLists() {
      this.expectedPaymentLoading = true;
      try {
        const res = await partnerBanksApi.getExpectedPaymentCheckLists();
        this.expectedPaymentCheckLists = (res && res.data) ? res.data : [];
      } catch (e) {
        this.expectedPaymentCheckLists = [];
      } finally {
        this.expectedPaymentLoading = false;
      }
    },
    async loadUsersForLogs(logs) {
      if (!logs || !logs.length) return;
      const userIds = new Set();
      logs.forEach((log) => {
        if (log.userId && Number.isFinite(log.userId) && log.userId > 0) {
          userIds.add(log.userId);
        }
      });
      if (userIds.size === 0) return;
      try {
        const users = await userService.getAllWithoutTenants();
        if (users && Array.isArray(users)) {
          users.forEach((user) => {
            if (user && user.id && userIds.has(user.id)) {
              this.$set(this.usersMap, user.id, user.username || `Kullanıcı ${user.id}`);
            }
          });
        }
      } catch (e) {
        void e;
      }
    },
    getUserName(userId) {
      if (!userId || !Number.isFinite(userId) || userId <= 0) return '-';
      return this.usersMap[userId] || `Kullanıcı ${userId}`;
    },
    async loadSnapshots() {
      this.snapshotsLoading = true;
      try {
        const res = await partnerBanksApi.getSnapshots(this.snapshotDateFilter || undefined);
        this.snapshots = (res && res.data) ? res.data : [];
      } catch (e) {
        this.snapshots = [];
      } finally {
        this.snapshotsLoading = false;
      }
    },
    getSnapshotData(item) {
      if (!item || !item.message) return {};
      if (item._parsed) return item._parsed;
      try {
        const obj = JSON.parse(item.message);
        item._parsed = obj || {};
      } catch (e) {
        item._parsed = {};
      }
      return item._parsed;
    },
    async openSnapshotDetail(item) {
      if (!this.companies || !this.companies.length) {
        await this.loadCompanies();
      }
      const data = this.getSnapshotData(item);
      this.snapshotDetailData = data;
      this.snapshotDetailDate = this.formatDate(item.createdAt);
      this.snapshotDetailDialog = true;
    },

    getMessageObject(message) {
      if (!message) return null;
      if (typeof message === 'object') return message;
      const raw = String(message).trim();
      if (!raw) return null;
      if (raw.startsWith('{') && raw.endsWith('}')) {
        try {
          return JSON.parse(raw);
        } catch (_e) {
          return null;
        }
      }
      return null;
    },

    formatTrNumber(value) {
      const num = Number(value);
      if (!Number.isFinite(num)) return '';
      const hasFraction = Math.abs(num % 1) > 0.000001;
      return new Intl.NumberFormat('tr-TR', {
        minimumFractionDigits: hasFraction ? 2 : 0,
        maximumFractionDigits: 2,
      }).format(num);
    },

    formatTl(value) {
      const t = this.formatTrNumber(value);
      return t ? `${t} TL` : '';
    },

    formatGr(value) {
      const g = this.formatTrNumber(value);
      return g ? `${g} gr` : '';
    },

    formatTlPerGr(value) {
      const t = this.formatTrNumber(value);
      return t ? `${t} TL/gr` : '';
    },

    getAvgTlPerGr(item) {
      const gram = item && item.totalGram ? Number(item.totalGram) : 0;
      const payment = item && item.totalPayment ? Number(item.totalPayment) : 0;
      if (!Number.isFinite(gram) || gram <= 0) return 0;
      if (!Number.isFinite(payment) || payment <= 0) return 0;
      return payment / gram;
    },

    buildGoldLogMessage(message) {
      const obj = this.getMessageObject(message);
      if (!obj) return message || '-';
      const bankName = obj.bankName ? String(obj.bankName) : (obj.BankName ? String(obj.BankName) : '');
      const gramsRaw = (obj.purchasedGrams !== undefined && obj.purchasedGrams !== null) ? obj.purchasedGrams : obj.PurchasedGrams;
      const paymentRaw = (obj.payment !== undefined && obj.payment !== null) ? obj.payment : obj.Payment;
      const purchasedGrams = this.formatGr(gramsRaw);
      const payment = this.formatTl(paymentRaw);
      const parts = [];
      if (purchasedGrams) parts.push(`Alınan Altın: ${purchasedGrams}`);
      if (payment) parts.push(`Ödenen Tutar: ${payment}`);
      const details = parts.length ? ` (${parts.join(', ')})` : '';
      return `Banka Altın Alımı: ${bankName}${details}`.trim();
    },

    buildCashLogMessage(message) {
      const obj = this.getMessageObject(message);
      if (!obj) return message || '-';
      const fromBank = obj.fromBank ? String(obj.fromBank) : (obj.FromBank ? String(obj.FromBank) : '');
      const toBank = obj.toBank ? String(obj.toBank) : (obj.ToBank ? String(obj.ToBank) : '');
      const transferredAmountRaw = (obj.transferredAmount !== undefined && obj.transferredAmount !== null) ? obj.transferredAmount : obj.TransferredAmount;
      const transferFeeRaw = (obj.transferFee !== undefined && obj.transferFee !== null) ? obj.transferFee : obj.TransferFee;
      const transferredAmount = this.formatTl(transferredAmountRaw);
      const transferFee = this.formatTl(transferFeeRaw);
      const bankPart = (fromBank || toBank) ? `${fromBank}${fromBank && toBank ? ' -> ' : ''}${toBank}` : '';
      const parts = [];
      if (transferredAmount) parts.push(`Tutar: ${transferredAmount}`);
      if (transferFee) parts.push(`Ücret: ${transferFee}`);
      const details = parts.length ? ` (${parts.join(', ')})` : '';
      return `Banka Nakit Transfer: ${bankPart}${details}`.trim();
    },
    buildGoldTransferLogMessage(message) {
      const obj = this.getMessageObject(message);
      if (!obj) return message || '-';
      const fromBank = obj.fromBank ? String(obj.fromBank) : (obj.FromBank ? String(obj.FromBank) : '');
      const toBank = obj.toBank ? String(obj.toBank) : (obj.ToBank ? String(obj.ToBank) : '');
      const gramsRaw = (obj.transferredGrams !== undefined && obj.transferredGrams !== null) ? obj.transferredGrams : obj.TransferredGrams;
      const grams = this.formatGr(gramsRaw);
      const bankPart = (fromBank || toBank) ? `${fromBank}${fromBank && toBank ? ' -> ' : ''}${toBank}` : '';
      const details = grams ? ` (Gram: ${grams})` : '';
      return `Banka Altın Transfer: ${bankPart}${details}`.trim();
    },
    buildExternalPaymentLogMessage(message) {
      const obj = this.getMessageObject(message);
      if (!obj) return message || '-';
      const bankName = obj.bankName ? String(obj.bankName) : (obj.BankName ? String(obj.BankName) : '');
      const paymentRaw = (obj.payment !== undefined && obj.payment !== null) ? obj.payment : obj.Payment;
      const paymentType = obj.paymentType ? String(obj.paymentType) : (obj.PaymentType ? String(obj.PaymentType) : '');
      const payment = this.formatTl(paymentRaw);
      const parts = [];
      if (payment) parts.push(`Tutar: ${payment}`);
      if (paymentType) parts.push(`Tip: ${paymentType}`);
      const details = parts.length ? ` (${parts.join(', ')})` : '';
      return `Dış Ödeme: ${bankName}${details}`.trim();
    },
    getExternalPaymentCompanyName(message) {
      const obj = this.getMessageObject(message);
      if (!obj) return '-';
      const cidRaw = (obj.companyId !== undefined && obj.companyId !== null) ? obj.companyId : obj.CompanyId;
      const cid = Number(cidRaw);
      if (!Number.isFinite(cid) || cid <= 0) return '-';
      return this.getCompanyName(cid);
    },
    getExternalPaymentBankName(message) {
      const obj = this.getMessageObject(message);
      if (!obj) return '-';
      return obj.bankName ? String(obj.bankName) : (obj.BankName ? String(obj.BankName) : '-');
    },
    getExternalPaymentType(message) {
      const obj = this.getMessageObject(message);
      if (!obj) return '-';
      return obj.paymentType ? String(obj.paymentType) : (obj.PaymentType ? String(obj.PaymentType) : '-');
    },
    getExternalPaymentAmount(message) {
      const obj = this.getMessageObject(message);
      if (!obj) return '-';
      const paymentRaw = (obj.payment !== undefined && obj.payment !== null) ? obj.payment : obj.Payment;
      return this.formatTl(paymentRaw);
    },

    getExtraDataPath(extraData) {
      if (!extraData) return '';
      const raw = String(extraData);

      const trimmed = raw.trim();
      if ((trimmed.startsWith('{') && trimmed.endsWith('}')) || (trimmed.startsWith('[') && trimmed.endsWith(']'))) {
        try {
          const obj = JSON.parse(trimmed);
          if (obj && typeof obj === 'object') {
            if (obj.path) return String(obj.path);
            if (obj.url) return String(obj.url);
            if (obj.receiptUrl) return String(obj.receiptUrl);
          }
        } catch (_e) {
          void _e;
        }
      }

      const urlMatch = raw.match(/https?:\/\/\S+/i);
      if (urlMatch && urlMatch[0]) return urlMatch[0];

      return String(raw || '').trim();
    },

    isFullUrl(value) {
      const v = String(value || '').trim();
      return /^https?:\/\//i.test(v) || v.startsWith('//');
    },

    async getReceiptPublicUrl(fileKey) {
      const response = await Api.get("/api/upload/public-url", { params: { fileKey } });
      return response && response.data ? response.data.url : null;
    },

    async openReceiptFromExtraData(extraData) {
      try {
        const value = this.getExtraDataPath(extraData);
        if (!value) return;

        if (this.isFullUrl(value)) {
          const url = String(value).trim().startsWith('//') ? `https:${String(value).trim()}` : String(value).trim();
          window.open(url, "_blank");
          return;
        }

        const url = await this.getReceiptPublicUrl(value);
        if (!url) {
          this.$store.state.dialog = true;
          this.$store.state.message = "Dekont linki oluşturulamadı.";
          return;
        }
        window.open(url, "_blank");
      } catch (error) {
        this.$store.state.dialog = true;
        this.$store.state.message = "Dekont açılırken bir hata oluştu.";
      }
    },

    async loadCompanies() {
      this.companiesLoading = true;
      try {
        const d = (await companiesApi.getCompanies()).data;
        this.companies = Array.isArray(d) ? d : [];
      } catch (e) {
        this.companies = [];
      } finally {
        this.companiesLoading = false;
      }
    },

    async loadBanks() {
      this.loading = true;
      try {
        await this.$store.dispatch('partnerBanks/searchPartnerBanks', {
          search: this.search,
          status: this.statusFilter,
          tenantId: this.tenantFilter || null,
          companyId: this.companyFilter || null
        });
      } catch (error) {
        console.error('Bankalar yüklenirken hata:', error);
      } finally {
        this.loading = false;
      }
    },

    searchBanks() {
      this.loadBanks();
    },

    openBankEditDialog(bank) {
      if (!bank || !bank.id) return;
      this.bankEditIsNew = false;
      this.bankEditModel = {
        id: bank.id,
        tenantId: bank.tenantId || null,
        companyId: bank.companyId || null,
        ibanIdentifier: bank.ibanIdentifier || '',
        bankName: bank.bankName || '',
        accountPurityType: bank.accountPurityType || null,
        goldAmountInGrams: bank.goldAmountInGrams === undefined ? null : bank.goldAmountInGrams,
        cashAmount: bank.cashAmount === undefined ? null : bank.cashAmount,
        status: bank.status || 'ACTIVE'
      };
      this.bankEditDialog = true;
    },

    openBankCreateDialog() {
      this.bankEditIsNew = true;
      this.bankEditModel = {
        id: null,
        tenantId: null,
        companyId: null,
        ibanIdentifier: '',
        bankName: '',
        accountPurityType: null,
        goldAmountInGrams: null,
        cashAmount: null,
        status: 'ACTIVE'
      };
      this.bankEditDialog = true;
    },

    closeBankEditDialog(force = false) {
      if (this.bankEditSaving && !force) return;
      this.bankEditDialog = false;
      this.bankEditIsNew = false;
      this.bankEditModel = {
        id: null,
        tenantId: null,
        companyId: null,
        ibanIdentifier: '',
        bankName: '',
        accountPurityType: null,
        goldAmountInGrams: null,
        cashAmount: null,
        status: 'ACTIVE'
      };
    },

    async submitBankEdit() {
      if (!this.bankEditModel.tenantId) return;
      if (!this.bankEditModel.companyId) return;
      if (!this.bankEditModel.bankName || !String(this.bankEditModel.bankName).trim()) return;
      if (!this.bankEditModel.ibanIdentifier || String(this.bankEditModel.ibanIdentifier).trim().length !== 3) return;
      if (!this.bankEditModel.status) return;

      this.bankEditSaving = true;
      try {
        const payload = Object.assign({}, this.bankEditModel, {
          ibanIdentifier: String(this.bankEditModel.ibanIdentifier || '').trim().toUpperCase(),
          bankName: String(this.bankEditModel.bankName || '').trim()
        });

        if (this.bankEditIsNew) {
          await this.$store.dispatch('partnerBanks/postPartnerBank', payload);
        } else {
          if (!payload.id) return;
          await this.$store.dispatch('partnerBanks/putPartnerBank', payload);
        }

        await this.loadBanks();
        this.closeBankEditDialog(true);
        this.$store.state.message = 'Banka kaydedildi!';
        this.$store.state.dialog = true;
      } catch (e) {
        alert('Kaydetme sırasında hata oluştu!');
      } finally {
        this.bankEditSaving = false;
      }
    },

    confirmDelete(bank) {
      this.bankToDelete = bank;
      this.deleteDialog = true;
    },

    async deleteBank() {
      if (!this.bankToDelete) return;
      
      this.deleting = true;
      try {
        await this.$store.dispatch('partnerBanks/deletePartnerBank', this.bankToDelete);
        this.deleteDialog = false;
        this.bankToDelete = null;
        this.$store.state.message = 'Banka başarıyla silindi!';
        this.$store.state.dialog = true;
      } catch (error) {
        alert('Silme işlemi sırasında hata oluştu!');
      } finally {
        this.deleting = false;
      }
    },

    openBuyGoldDialog(bank) {
      this.selectedBank = bank;
      this.buyGoldPayment = null;
      this.buyGoldGram = null;
      this.buyGoldReceiptFileKey = '';
      this.buyGoldReceiptUrl = '';
      this.buyGoldDialog = true;
    },

    async submitBuyGold() {
      if (!this.selectedBank || !this.selectedBank.bankName) return;
      if (!this.selectedBank.companyId) return;
      if (this.buyGoldPayment === null || this.buyGoldPayment === undefined || this.buyGoldPayment < 0) return;
      if (this.buyGoldGram === null || this.buyGoldGram === undefined || this.buyGoldGram <= 0) return;

      this.buyGoldSaving = true;
      try {
        await this.$store.dispatch('partnerBanks/buyGold', {
          bankName: this.selectedBank.bankName,
          companyId: this.selectedBank.companyId,
          payment: this.buyGoldPayment,
          gram: this.buyGoldGram,
          receiptUrl: this.buyGoldReceiptFileKey || ''
        });
        await this.loadBanks();
        this.buyGoldDialog = false;
        this.$store.state.message = 'Altın alımı başarıyla tamamlandı!';
        this.$store.state.dialog = true;
      } catch (error) {
        alert('Altın alımı sırasında hata oluştu!');
      } finally {
        this.buyGoldSaving = false;
      }
    },

    openTransferDialog(bank) {
      this.selectedBank = bank;
      this.transferToBankName = '';
      this.transferAmount = null;
      this.transferFee = 0;
      this.transferReceiptFileKey = '';
      this.transferReceiptUrl = '';
      this.transferDialog = true;
    },

    async submitTransfer() {
      if (!this.selectedBank || !this.selectedBank.bankName) return;
      if (!this.selectedBank.companyId) return;
      if (!this.transferToBankName) return;
      if (this.transferAmount === null || this.transferAmount === undefined || this.transferAmount <= 0) return;
      if (this.transferFee === null || this.transferFee === undefined || this.transferFee < 0) return;

      this.transferSaving = true;
      try {
        await this.$store.dispatch('partnerBanks/transferCashToAnotherBank', {
          fromBankName: this.selectedBank.bankName,
          toBankName: this.transferToBankName,
          companyId: this.selectedBank.companyId,
          amount: this.transferAmount,
          transferFee: this.transferFee,
          receiptUrl: this.transferReceiptFileKey || ''
        });
        await this.loadBanks();
        this.transferDialog = false;
        this.$store.state.message = 'Para transferi başarıyla tamamlandı!';
        this.$store.state.dialog = true;
      } catch (error) {
        alert('Para transferi sırasında hata oluştu!');
      } finally {
        this.transferSaving = false;
      }
    },

    openGoldTransferDialog(bank) {
      this.selectedBank = bank;
      this.goldTransferToBankName = '';
      this.goldTransferGram = null;
      this.goldTransferFee = 0;
      this.goldTransferReceiptFileKey = '';
      this.goldTransferReceiptUrl = '';
      this.goldTransferDialog = true;
    },

    async submitGoldTransfer() {
      if (!this.selectedBank || !this.selectedBank.bankName) return;
      if (!this.selectedBank.companyId) return;
      if (!this.goldTransferToBankName) return;
      if (this.goldTransferGram === null || this.goldTransferGram === undefined || this.goldTransferGram <= 0) return;
      if (this.goldTransferFee === null || this.goldTransferFee === undefined || this.goldTransferFee < 0) return;

      this.goldTransferSaving = true;
      try {
        await this.$store.dispatch('partnerBanks/transferGoldToAnotherBank', {
          fromBankName: this.selectedBank.bankName,
          toBankName: this.goldTransferToBankName,
          companyId: this.selectedBank.companyId,
          gram: this.goldTransferGram,
          transferFee: this.goldTransferFee,
          receiptUrl: this.goldTransferReceiptFileKey || ''
        });
        await this.loadBanks();
        this.goldTransferDialog = false;
        this.$store.state.message = 'Altın transferi başarıyla tamamlandı!';
        this.$store.state.dialog = true;
      } catch (error) {
        alert('Altın transferi sırasında hata oluştu!');
      } finally {
        this.goldTransferSaving = false;
      }
    },

    openExternalPaymentsDialog(bank) {
      this.selectedBank = bank;
      this.externalPaymentAmount = null;
      this.externalPaymentType = null;
      this.externalPaymentTypeOtherText = '';
      this.externalPaymentsDialog = true;
    },

    async submitExternalPayments() {
      if (!this.selectedBank || !this.selectedBank.bankName) return;
      if (!this.selectedBank.companyId) return;
      if (this.externalPaymentAmount === null || this.externalPaymentAmount === undefined || this.externalPaymentAmount <= 0) return;
      if (!this.externalPaymentType || !String(this.externalPaymentType).trim()) return;
      if (this.externalPaymentType === 'DIGER' && (!this.externalPaymentTypeOtherText || !String(this.externalPaymentTypeOtherText).trim())) return;

      this.externalPaymentsSaving = true;
      try {
        await this.$store.dispatch('partnerBanks/processExternalPayments', {
          bankName: this.selectedBank.bankName,
          companyId: this.selectedBank.companyId,
          payment: this.externalPaymentAmount,
          paymentType: String(this.externalPaymentType).trim(),
          paymentTypeOtherText: this.externalPaymentType === 'DIGER'
            ? String(this.externalPaymentTypeOtherText).trim()
            : '',
        });
        await this.loadBanks();
        this.externalPaymentsDialog = false;
        this.$store.state.message = 'Dış ödeme başarıyla kaydedildi!';
        this.$store.state.dialog = true;
      } catch (error) {
        alert('Dış ödeme sırasında hata oluştu!');
      } finally {
        this.externalPaymentsSaving = false;
      }
    },

    openIncomingPaymentDialog(bank) {
      this.selectedBank = bank;
      this.incomingPaymentAmount = null;
      this.incomingPaymentDialog = true;
    },

    async submitIncomingPayment() {
      if (!this.selectedBank || !this.selectedBank.bankName) return;
      if (!this.selectedBank.companyId) return;
      if (this.incomingPaymentAmount === null || this.incomingPaymentAmount === undefined || this.incomingPaymentAmount <= 0) return;

      this.incomingPaymentSaving = true;
      try {
        await this.$store.dispatch('partnerBanks/addIncomingPayment', {
          bankName: this.selectedBank.bankName,
          companyId: this.selectedBank.companyId,
          amount: this.incomingPaymentAmount,
        });
        await this.loadBanks();
        this.incomingPaymentDialog = false;
        this.$store.state.message = 'Gelen ödeme başarıyla kaydedildi!';
        this.$store.state.dialog = true;
      } catch (error) {
        alert('Gelen ödeme sırasında hata oluştu!');
      } finally {
        this.incomingPaymentSaving = false;
      }
    },

    triggerReceiptInput(target) {
      if (this.receiptUploading) return;
      this.receiptTarget = target || '';
      if (this.$refs && this.$refs.receiptFileInput) {
        this.$refs.receiptFileInput.click();
      }
    },

    async onReceiptFileSelected(event) {
      const files = event && event.target ? event.target.files : null;
      if (!files || files.length === 0) return;
      const file = files[0];
      if (!this.receiptTarget) return;

      this.receiptUploading = true;
      try {
        const presignedResponse = await Api.post("/api/upload/presigned-url-receipt", {
          fileName: file.name,
          contentType: file.type || "application/octet-stream",
        });
        const { uploadUrl, fileKey } = presignedResponse.data;

        await axios.put(uploadUrl, file, {
          headers: { "Content-Type": file.type || "application/octet-stream" },
        });

        const response = await Api.get("/api/upload/public-url", { params: { fileKey } });
        const url = response && response.data ? response.data.url : '';

        if (this.receiptTarget === 'buyGold') {
          this.buyGoldReceiptFileKey = fileKey || '';
          this.buyGoldReceiptUrl = url || '';
        } else if (this.receiptTarget === 'transfer') {
          this.transferReceiptFileKey = fileKey || '';
          this.transferReceiptUrl = url || '';
        } else if (this.receiptTarget === 'goldTransfer') {
          this.goldTransferReceiptFileKey = fileKey || '';
          this.goldTransferReceiptUrl = url || '';
        }

        this.$store.state.dialog = true;
        this.$store.state.message = "Dekont başarıyla yüklendi.";
      } catch (error) {
        this.$store.state.dialog = true;
        this.$store.state.message = "Dekont yüklenirken bir hata oluştu.";
      } finally {
        this.receiptUploading = false;
        if (this.$refs && this.$refs.receiptFileInput) {
          this.$refs.receiptFileInput.value = "";
        }
      }
    },

    clearReceipt(target) {
      if (target === 'buyGold') {
        this.buyGoldReceiptFileKey = '';
        this.buyGoldReceiptUrl = '';
      } else if (target === 'transfer') {
        this.transferReceiptFileKey = '';
        this.transferReceiptUrl = '';
      } else if (target === 'goldTransfer') {
        this.goldTransferReceiptFileKey = '';
        this.goldTransferReceiptUrl = '';
      }
    },

    getReceiptFileName(fileKey) {
      if (!fileKey) return '';
      const parts = String(fileKey).split("/");
      return parts[parts.length - 1];
    },

    async copyText(text) {
      try {
        if (!text) return;
        await navigator.clipboard.writeText(text);
        this.$store.state.dialog = true;
        this.$store.state.message = "Dekont linki kopyalandı.";
      } catch (error) {
        this.$store.state.dialog = true;
        this.$store.state.message = "Dekont linki kopyalanamadı.";
      }
    },

    openUrl(url) {
      if (!url) return;
      window.open(url, "_blank");
    },

    formatDate(date) {
      return date ? moment(date).format('DD.MM.YYYY HH:mm') : '-';
    },

    formatDateOnly(date) {
      return date ? moment(date).format('DD.MM.YYYY') : '-';
    },

    formatGoldAmount(amount) {
      if (!amount) return '-';
      return new Intl.NumberFormat('tr-TR', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(amount);
    },

    formatCashAmount(amount) {
      if (amount === null || amount === undefined) return '-';
      return new Intl.NumberFormat('tr-TR', {
        style: 'currency',
        currency: 'TRY',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(amount);
    },

    getPurityColor(purity) {
      switch(purity) {
        case 1000: return 'yellow darken-1';
        case 995: return 'amber darken-1';
        case 916: return 'deep-orange';
        default: return 'grey';
      }
    },

    getPurityColorSlug(purity) {
      switch(purity) {
        case 1000: return 'yellow';
        case 995: return 'amber';
        case 916: return 'deep-orange';
        default: return 'grey';
      }
    },

    getCompanyName(companyId) {
      if (!companyId) return '-';
      const c = this.companiesById[companyId];
      return c && c.name ? c.name : String(companyId);
    },

    getTenantName(tenantId) {
      switch(tenantId) {
        case 1: return 'ALTINDAFIRSAT';
        case 2: return 'E-ALTIN';
        default: return 'Bilinmiyor';
      }
    },
  },

  mounted() {
    this.loadCompanies();
    this.loadBanks();
  }
};
</script>

<style scoped>
.partner-bank-tabs >>> .v-tabs__bar {
  background: linear-gradient(135deg, #1d4ed8, #2563eb) !important;
}

.partner-bank-tabs >>> .v-tabs__item {
  color: #ffffff !important;
  opacity: 0.78;
  font-weight: 800;
  letter-spacing: 0.2px;
  text-transform: none;
}

.partner-bank-tabs >>> .v-tabs__item--active {
  opacity: 1;
  font-weight: 900;
  background: rgba(255, 255, 255, 0.14);
  border-radius: 10px;
}

.partner-bank-tabs >>> .v-tabs__slider {
  background-color: #ffffff !important;
  height: 4px !important;
}

.v-chip {
  font-weight: 600;
}

.bank-modal {
  overflow: hidden;
}

.modern-card {
  border-radius: 16px;
  border: 1px solid rgba(148, 163, 184, 0.26) !important;
  background: #ffffff;
  box-shadow: 0 10px 24px rgba(15, 23, 42, 0.08) !important;
  overflow: hidden;
}

.receipt-shell {
  border-radius: 12px;
  overflow: hidden;
  border: 1px solid rgba(148, 163, 184, 0.35);
}

.receipt-header {
  padding: 14px 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid rgba(148, 163, 184, 0.25);
  background: #fff;
}

.receipt-header-left {
  display: flex;
  align-items: center;
  gap: 12px;
}

.receipt-icon {
  width: 40px;
  height: 40px;
  border-radius: 10px;
  background: rgba(25, 118, 210, 0.10);
  display: flex;
  align-items: center;
  justify-content: center;
}

.receipt-title {
  font-weight: 700;
  font-size: 16px;
  color: #0f172a;
  line-height: 1.1;
}

.receipt-subtitle {
  font-size: 12px;
  color: #64748b;
  margin-top: 2px;
}

.receipt-count-pill {
  padding: 6px 10px;
  border-radius: 999px;
  background: rgba(16, 185, 129, 0.10);
  color: #059669;
  font-weight: 700;
  font-size: 12px;
}

.receipt-body {
  padding: 14px 16px 16px;
  background: #fff;
}

.receipt-dropzone {
  border-radius: 14px;
  padding: 16px;
  cursor: pointer;
  user-select: none;
  background: linear-gradient(135deg, #1d4ed8, #2563eb);
  color: white;
  display: grid;
  grid-template-columns: 40px 1fr;
  gap: 12px;
  align-items: center;
  box-shadow: 0 10px 22px rgba(29, 78, 216, 0.18);
}

.receipt-dropzone-icon {
  width: 40px;
  height: 40px;
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.16);
  display: flex;
  align-items: center;
  justify-content: center;
}

.receipt-dropzone-title {
  font-weight: 900;
  letter-spacing: 0.6px;
  font-size: 14px;
}

.receipt-dropzone-desc {
  grid-column: 2 / 3;
  font-size: 12px;
  opacity: 0.9;
  margin-top: -4px;
}

.receipt-single {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  padding: 10px 12px;
  border-radius: 12px;
  border: 1px solid rgba(148, 163, 184, 0.26);
  background: rgba(248, 250, 252, 0.9);
}

.receipt-single-name {
  font-weight: 700;
  font-size: 12px;
  color: #0f172a;
  max-width: 280px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.receipt-single-actions {
  display: flex;
  align-items: center;
  gap: 8px;
}

.receipt-open-btn {
  border-radius: 10px !important;
  font-weight: 800 !important;
  letter-spacing: 0.4px !important;
}

.partner-tab-section {
  max-width: 80rem;
  margin: 0 auto;
  padding: 2rem 1.5rem;
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, sans-serif;
}

.refined-header {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  margin-bottom: 1.5rem;
}

.refined-title {
  font-size: 1.5rem;
  font-weight: 700;
  color: #0f172a;
  margin: 0;
  letter-spacing: -0.025em;
}

.refined-subtitle {
  font-size: 0.875rem;
  color: #64748b;
  margin: 0.25rem 0 0 0;
}

.refined-primary-btn {
  display: inline-flex;
  align-items: center;
  background: #2563eb;
  color: #fff;
  padding: 0.625rem 1.5rem;
  border-radius: 0.5rem;
  font-weight: 600;
  font-size: 0.875rem;
  border: none;
  cursor: pointer;
  text-decoration: none;
  box-shadow: 0 1px 2px rgba(37, 99, 235, 0.2);
  transition: background 0.2s, box-shadow 0.2s;
}

.refined-primary-btn:hover {
  background: #1d4ed8;
}

.refined-primary-btn:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}

.refined-btn-amber {
  background: #d97706;
  box-shadow: 0 1px 2px rgba(217, 119, 6, 0.2);
}

.refined-btn-amber:hover:not(:disabled) {
  background: #b45309;
}

.refined-btn-success {
  background: #059669;
  box-shadow: 0 1px 2px rgba(5, 150, 105, 0.2);
}

.refined-btn-success:hover:not(:disabled) {
  background: #047857;
}

.refined-header-actions {
  display: flex;
  align-items: center;
  gap: 0.75rem;
}

.refined-date-btn {
  display: inline-flex;
  align-items: center;
  padding: 0.5rem 1rem;
  border-radius: 0.5rem;
  border: 1px solid #e2e8f0;
  background: #fff;
  color: #475569;
  font-size: 0.875rem;
  cursor: pointer;
  transition: border-color 0.2s, background 0.2s;
}

.refined-date-btn:hover {
  border-color: #2563eb;
  background: #f8fafc;
}

.refined-filters {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  margin-bottom: 1.5rem;
}

.refined-filter-item {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}

.refined-filter-label {
  font-size: 0.75rem;
  font-weight: 600;
  color: #64748b;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.refined-input,
.refined-select {
  padding: 0.5rem 0.75rem;
  border-radius: 0.5rem;
  border: 1px solid #e2e8f0;
  font-size: 0.875rem;
  color: #0f172a;
  min-width: 180px;
}

.refined-input:focus,
.refined-select:focus {
  outline: none;
  border-color: #2563eb;
  box-shadow: 0 0 0 2px rgba(37, 99, 235, 0.15);
}

.refined-table-wrap {
  background: #fff;
  border-radius: 0.625rem;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
  border: 1px solid #e2e8f0;
  overflow: hidden;
}

.refined-table-scroll {
  overflow-x: auto;
}

.refined-table {
  width: 100%;
  text-align: left;
  border-collapse: collapse;
}

.refined-table thead tr {
  background: #f8fafc;
  border-bottom: 1px solid #e2e8f0;
}

.refined-table th {
  padding: 1rem 1.5rem;
  font-size: 0.75rem;
  font-weight: 600;
  color: #64748b;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.refined-th-dekont {
  width: 120px;
  text-align: center;
}

.refined-table tbody tr {
  border-bottom: 1px solid #f1f5f9;
  transition: background 0.15s;
}

.refined-table tbody tr:hover {
  background: rgba(248, 250, 252, 0.7);
}

.refined-table td {
  padding: 1rem 1.5rem;
  font-size: 0.875rem;
  color: #475569;
}

.refined-cell-bold {
  font-weight: 600;
  color: #1e293b;
}

.refined-cell-value {
  font-weight: 500;
  color: #1e293b;
}

.refined-icon-inline {
  vertical-align: middle;
  margin-left: 2px;
}

.refined-muted {
  color: #94a3b8;
}

.refined-chip {
  display: inline-block;
  padding: 0.25rem 0.5rem;
  border-radius: 0.375rem;
  font-size: 0.75rem;
  font-weight: 600;
}

.refined-chip-success {
  background: rgba(16, 185, 129, 0.15);
  color: #059669;
}

.refined-chip-error {
  background: rgba(239, 68, 68, 0.15);
  color: #dc2626;
}

.refined-chip-yellow {
  background: rgba(234, 179, 8, 0.2);
  color: #b45309;
}

.refined-chip-amber {
  background: rgba(245, 158, 11, 0.2);
  color: #d97706;
}

.refined-chip-deep-orange {
  background: rgba(234, 88, 12, 0.2);
  color: #ea580c;
}

.refined-chip-grey {
  background: #f1f5f9;
  color: #64748b;
}

.refined-action-btn {
  padding: 0.35rem 0.75rem;
  border-radius: 0.375rem;
  border: none;
  background: #2563eb;
  color: #fff;
  font-size: 0.8125rem;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.2s;
}

.refined-action-btn:hover {
  background: #1d4ed8;
}

.refined-dekont-btn {
  padding: 0.35rem 0.75rem;
  border-radius: 0.375rem;
  border: none;
  background: #2563eb;
  color: #fff;
  font-size: 0.8125rem;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.2s;
}

.refined-dekont-btn:hover {
  background: #1d4ed8;
}

.refined-cell-dekont {
  text-align: center;
  width: 120px;
}

.refined-menu-card {
  border-radius: 0.625rem;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);
  border: 1px solid #e2e8f0;
  overflow: hidden;
}

.refined-menu-body {
  padding: 0.5rem;
  min-width: 180px;
}

.refined-menu-btn {
  display: block;
  width: 100%;
  padding: 0.625rem 1rem;
  border: none;
  border-radius: 0.5rem;
  font-size: 0.8125rem;
  font-weight: 700;
  letter-spacing: 0.03em;
  text-transform: uppercase;
  color: #fff;
  cursor: pointer;
  transition: opacity 0.2s, filter 0.2s;
  margin-bottom: 0.375rem;
}

.refined-menu-btn:last-child {
  margin-bottom: 0;
}

.refined-menu-btn:hover {
  opacity: 0.92;
  filter: brightness(1.05);
}

.refined-menu-btn-primary {
  background: #2563eb;
}

.refined-menu-btn-amber {
  background: #d97706;
}

.refined-menu-btn-success {
  background: #059669;
}

.refined-menu-btn-indigo {
  background: #4f46e5;
}

.refined-menu-btn-cyan {
  background: #0891b2;
}

.refined-menu-btn-error {
  background: #dc2626;
}

.bank-edit-bold-label >>> .v-label {
  font-weight: 800 !important;
}

.refined-menu-divider {
  height: 1px;
  background: #e2e8f0;
  margin: 0.5rem 0;
}

.refined-table-footer {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 1.5rem;
  padding: 1rem 1.5rem;
  background: rgba(248, 250, 252, 0.6);
  font-size: 0.875rem;
  color: #64748b;
  flex-wrap: wrap;
}

.refined-footer-left {
  display: flex;
  align-items: center;
  gap: 0.75rem;
}

.refined-rows-select {
  background: transparent;
  border: none;
  color: #0f172a;
  cursor: pointer;
  font-weight: 500;
  padding: 0.25rem 0;
}

.refined-rows-select:focus {
  outline: none;
}

.refined-pagination-info {
  margin-left: auto;
}

.refined-footer-actions {
  display: flex;
  align-items: center;
  gap: 0.25rem;
}

.refined-page-btn {
  padding: 0.25rem;
  border: none;
  background: transparent;
  border-radius: 0.25rem;
  cursor: pointer;
  color: #64748b;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.refined-page-btn:hover:not(:disabled) {
  background: #e2e8f0;
  color: #0f172a;
}

.refined-page-btn:disabled {
  opacity: 0.35;
  cursor: not-allowed;
}

.refined-loading,
.refined-empty {
  text-align: center;
  padding: 2rem !important;
  color: #64748b;
}

.dekont-cell {
  width: 180px;
  min-width: 180px;
  max-width: 180px;
  padding-left: 8px !important;
  padding-right: 8px !important;
  vertical-align: middle;
}

.dekont-btn {
  margin: 0 !important;
}

.daily-gold-summary {
  max-width: 80rem;
  margin: 0 auto;
  padding: 2rem 1.5rem;
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, sans-serif;
}

.gold-summary-header {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  margin-bottom: 2rem;
}

.gold-summary-title {
  font-size: 1.5rem;
  font-weight: 700;
  color: #0f172a;
  margin: 0;
  letter-spacing: -0.025em;
}

.gold-summary-date {
  font-size: 0.875rem;
  color: #64748b;
  margin: 0.25rem 0 0 0;
}

.gold-summary-refresh-btn {
  display: inline-flex;
  align-items: center;
  background: #2563eb;
  color: #fff;
  padding: 0.625rem 1.5rem;
  border-radius: 0.5rem;
  font-weight: 600;
  font-size: 0.875rem;
  border: none;
  cursor: pointer;
  box-shadow: 0 1px 2px rgba(37, 99, 235, 0.2);
  transition: background 0.2s, box-shadow 0.2s;
}

.gold-summary-refresh-btn:hover:not(:disabled) {
  background: #1d4ed8;
}

.gold-summary-refresh-btn:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}

.gold-summary-table-wrap {
  background: #fff;
  border-radius: 0.625rem;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
  border: 1px solid #e2e8f0;
  overflow: hidden;
  margin-bottom: 2rem;
}

.gold-summary-table-scroll {
  overflow-x: auto;
}

.gold-summary-table {
  width: 100%;
  text-align: left;
  border-collapse: collapse;
}

.gold-summary-table thead tr {
  background: #f8fafc;
  border-bottom: 1px solid #e2e8f0;
}

.gold-summary-table th {
  padding: 1rem 1.5rem;
  font-size: 0.75rem;
  font-weight: 600;
  color: #64748b;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.gold-summary-table tbody tr {
  border-bottom: 1px solid #f1f5f9;
  transition: background 0.15s;
}

.gold-summary-table tbody tr:hover {
  background: rgba(248, 250, 252, 0.7);
}

.gold-summary-table td {
  padding: 1rem 1.5rem;
  font-size: 0.875rem;
  color: #475569;
}

.gold-summary-cell-name {
  font-weight: 600;
  color: #1e293b;
}

.gold-summary-loading,
.gold-summary-empty {
  text-align: center;
  padding: 2rem !important;
  color: #64748b;
}

.gold-summary-table-footer {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 1.5rem;
  padding: 1rem 1.5rem;
  background: rgba(248, 250, 252, 0.6);
  font-size: 0.875rem;
  color: #64748b;
  flex-wrap: wrap;
}

.gold-summary-footer-left {
  display: flex;
  align-items: center;
  gap: 0.75rem;
}

.gold-summary-rows-select {
  background: transparent;
  border: none;
  color: #0f172a;
  cursor: pointer;
  font-weight: 500;
  padding: 0.25rem 0;
}

.gold-summary-rows-select:focus {
  outline: none;
}

.gold-summary-pagination-info {
  margin-left: auto;
}

.gold-summary-footer-actions {
  display: flex;
  align-items: center;
  gap: 0.25rem;
}

.gold-summary-page-btn {
  padding: 0.25rem;
  border: none;
  background: transparent;
  border-radius: 0.25rem;
  cursor: pointer;
  color: #64748b;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.gold-summary-page-btn:hover:not(:disabled) {
  background: #e2e8f0;
  color: #0f172a;
}

.gold-summary-page-btn:disabled {
  opacity: 0.35;
  cursor: not-allowed;
}

.gold-summary-cards {
  display: grid;
  grid-template-columns: repeat(1, 1fr);
  gap: 1rem;
}

@media (min-width: 768px) {
  .gold-summary-cards {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (min-width: 1024px) {
  .gold-summary-cards {
    grid-template-columns: repeat(4, 1fr);
  }
}

.gold-summary-card {
  background: #fff;
  padding: 1.25rem;
  border-radius: 0.625rem;
  border: 1px solid #e2e8f0;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);
  transition: box-shadow 0.2s;
}

.gold-summary-card:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
}

.gold-summary-card-head {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 0.75rem;
}

.gold-summary-card-label {
  font-size: 0.6875rem;
  font-weight: 700;
  color: #94a3b8;
  text-transform: uppercase;
  letter-spacing: 0.1em;
}

.gold-summary-card-icon {
  width: 2.25rem;
  height: 2.25rem;
  border-radius: 0.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: transform 0.2s;
}

.gold-summary-card:hover .gold-summary-card-icon {
  transform: scale(1.1);
}

.gold-summary-icon-emerald {
  background: rgba(16, 185, 129, 0.1);
  color: #059669;
}

.gold-summary-icon-amber {
  background: rgba(245, 158, 11, 0.1);
  color: #d97706;
}

.gold-summary-icon-yellow {
  background: rgba(234, 179, 8, 0.1);
  color: #ca8a04;
}

.gold-summary-icon-primary {
  background: rgba(37, 99, 235, 0.08);
  color: #2563eb;
}

.gold-summary-icon-slate {
  background: #f1f5f9;
  color: #475569;
}

.gold-summary-icon-rose {
  background: rgba(244, 63, 94, 0.1);
  color: #e11d48;
}

.gold-summary-icon-indigo {
  background: rgba(99, 102, 241, 0.1);
  color: #4f46e5;
}

.gold-summary-icon-cyan {
  background: rgba(6, 182, 212, 0.1);
  color: #0891b2;
}

.gold-summary-icon-green {
  background: rgba(34, 197, 94, 0.1);
  color: #16a34a;
}

.gold-summary-card-value {
  font-size: 1.5rem;
  font-weight: 700;
  color: #0f172a;
  letter-spacing: -0.025em;
  line-height: 1.2;
}

.gold-summary-no-data {
  margin-top: 1.5rem;
  border-radius: 0.625rem;
}
</style>